/**
 * This file is auto-generated by Amplitude.
 * To update run 'ampli pull web'
 *
 * Works with versions ^2.0.8 of @itly/sdk and @itly/plugin's
 * https://www.npmjs.com/search?q=%40itly
 */

/* tslint:disable */
/* eslint-disable */
import {
  ItlyBrowser,
  Options as OptionsBase,
  Event as EventBase,
  Plugin,
  Environment as EnvironmentBase,
  Properties as PropertiesBase,
  ValidationResponse as ValidationResponseBase,
  CallOptions as CallOptionsBase,
  PluginCallOptions as PluginCallOptionsBase,
} from '@itly/sdk';
import SchemaValidatorPlugin from '@itly/plugin-schema-validator';
import {
  SegmentPlugin,
  SegmentOptions,
  SegmentAliasOptions as SegmentAliasOptionsBase,
  SegmentIdentifyOptions as SegmentIdentifyOptionsBase,
  SegmentGroupOptions as SegmentGroupOptionsBase,
  SegmentPageOptions as SegmentPageOptionsBase,
  SegmentTrackOptions as SegmentTrackOptionsBase,
} from '@itly/plugin-segment';

export type Options = OptionsBase;
export type Environment = EnvironmentBase;
export type Event = EventBase;
export type Properties = PropertiesBase;
export type ValidationResponse = ValidationResponseBase;
export type CallOptions = CallOptionsBase;
export type PluginCallOptions = PluginCallOptionsBase;
export { Plugin, Validation, Loggers } from '@itly/sdk';
export type SegmentAliasOptions = SegmentAliasOptionsBase;
export type SegmentIdentifyOptions = SegmentIdentifyOptionsBase;
export type SegmentGroupOptions = SegmentGroupOptionsBase;
export type SegmentPageOptions = SegmentPageOptionsBase;
export type SegmentTrackOptions = SegmentTrackOptionsBase;

export interface AliasOptions extends CallOptions {
  segment?: SegmentAliasOptions;
}

export interface IdentifyOptions extends CallOptions {
  segment?: SegmentIdentifyOptions;
}

export interface GroupOptions extends CallOptions {
  segment?: SegmentGroupOptions;
}

export interface PageOptions extends CallOptions {
  segment?: SegmentPageOptions;
}

export interface TrackOptions extends CallOptions {
  segment?: SegmentTrackOptions;
}

export interface ContextProperties {
  /**
   * Editor version (1 or 2). Required for any events in Editor
   */
  au_project_version?: string;
  /**
   * INACTIVE
   */
  au_split_editorV2_books?: string;
  au_split_editorV2_feature_flag_autofill?: boolean;
  au_split_editorV2_guestbookset?: string;
  /**
   * Split for Spread Books testing
   */
  au_split_editorV2_spread_books?: string;
  /**
   * Property containing the split treatment for whether the Google log in/sign up buttons are shown to the user
   */
  au_split_feature_flag_google_sign_in?: boolean;
  /**
   * Property containing the split treatment for the new product search experience at commerce
   */
  au_split_feature_flag_product_search?: boolean;
  "au_split_featureflag-chooseimagemodalflow"?: boolean;
  /**
   * Editor minor version (e.g. 1.62.1)
   */
  editor_version?: string;
  /**
   * Is the user using a mobile device?
   */
  is_mobile_view?: boolean;
}

export interface IdentifyProperties {
  email?: string;
  first_name?: string;
  last_name?: string;
  /**
   * Used downstream for Blueshift. Set to false in the case of a Gleam pop-up or other indicator that they should be resubscribed to our mailing list.
   */
  unsubscribed?: boolean;
}

export interface AccountCreatedProperties {
  /**
   * The customer's email address
   */
  email?: string;
  /**
   * The customer's Magento ID
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  user_id: number;
}

export interface ApplyPromoCodeProperties {
  /**
   * [sales_order.quote_id]
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  cart_id?: number;
  promo_code: string;
}

export interface ApplyPromoCodeErrorProperties {
  /**
   * [sales_order.quote_id]
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  cart_id?: number;
  promo_code: string;
  promo_code_error: string;
}

export interface AssetClickedProperties {
  creative: string;
  location: string;
  navigation_target: string;
}

export interface CartPageTotalLoadTimeProperties {
  /**
   * [sales_order.quote_id]
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  cart_id?: number;
  /**
   * The customer's email address
   */
  email?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  load_time: number;
}

export interface CartViewedProperties {
  /**
   * Editor version (1 or 2). Required for any events in Editor
   */
  au_project_version?: string;
  /**
   * INACTIVE
   */
  au_split_editorV2_books?: string;
  au_split_editorV2_feature_flag_autofill?: boolean;
  au_split_editorV2_guestbookset?: string;
  /**
   * Split for Spread Books testing
   */
  au_split_editorV2_spread_books?: string;
  /**
   * Property containing the split treatment for whether the Google log in/sign up buttons are shown to the user
   */
  au_split_feature_flag_google_sign_in?: boolean;
  /**
   * Property containing the split treatment for the new product search experience at commerce
   */
  au_split_feature_flag_product_search?: boolean;
  "au_split_featureflag-chooseimagemodalflow"?: boolean;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  base_total?: number;
  /**
   * Represents quote_id in Magento
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  cart_id?: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  discount_amount?: number;
  /**
   * Editor minor version (e.g. 1.62.1)
   */
  editor_version?: string;
  /**
   * Is the user using a mobile device?
   */
  is_mobile_view?: boolean;
  /**
   * Products in the order. Should contain the following properties:
   *
   * product_id sku name price quantity category (aka: Reporting Product Category) product*line (aka: Reporting Product Line)* discount_amount discounted_total project_id
   *
   * | Rule | Value |
   * |---|---|
   * | Item Type | object |
   */
  products: {
    [k: string]: unknown;
  }[];
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  shipping_price?: number;
  /**
   * * amount
   *
   * * method_title
   *
   * * estimated*\_*arrival_time
   *
   * | Rule | Value |
   * |---|---|
   * | Item Type | object |
   */
  shipping_properties?: {
    [k: string]: unknown;
  }[];
  /**
   * Order total before discounts, taxes and shipping; essentially gross product revenue
   * [sales_order.base_subtotal]
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  subtotal?: number;
  /**
   * Total tax associated with the transaction [sales_order.base_tax_amount]
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  tax?: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  total?: number;
}

export interface CheckoutErrorProperties {
  /**
   * [sales_order.quote_id]
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  cart_id?: number;
  error: {
    [k: string]: unknown;
  };
  error_message: string;
}

export interface CheckoutPageTotalLoadTimeProperties {
  /**
   * [sales_order.quote_id]
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  cart_id?: number;
  /**
   * The customer's email address
   */
  email?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  load_time: number;
}

export interface CheckoutStartedProperties {
  /**
   * Represents quote_id in Magento
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  cart_id?: number;
  /**
   * Transaction coupon redeemed with the transaction
   */
  coupon?: string;
  /**
   * Currency code associated with the transaction
   */
  currency: string;
  /**
   * Products in the order. Should contain the following properties:
   *
   * product_id
   * sku
   * name
   * price
   * quantity
   * category (aka: Reporting Product Category)
   * product_line (aka: Reporting Product Line)
   *
   * | Rule | Value |
   * |---|---|
   * | Item Type | object |
   */
  products: {
    [k: string]: unknown;
  }[];
  /**
   * Revenue ($) associated with the transaction (excluding tax) (cart.base_subtotal - cart.discount_amount)
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  revenue: number;
}

export interface CheckoutStepCompletedProperties {
  /**
   * Editor version (1 or 2). Required for any events in Editor
   */
  au_project_version?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  base_total?: number;
  /**
   * [sales_order.quote_id]
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  cart_id?: number;
  /**
   * Represents quote_id in Magento
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  checkout_id: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  discount_amount?: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  discounted_total?: number;
  /**
   * Editor minor version (e.g. 1.62.1)
   */
  editor_version?: string;
  /**
   * Is the user using a mobile device?
   */
  is_mobile_view?: boolean;
  /**
   * String representing the payment method chosen
   */
  payment_method?: string;
  /**
   * Price as displayed to the customer; in some events, such as Product Viewed and Product List Viewed, this will be set to the Lowest Price since price can change based on options selected
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  price?: number;
  /**
   * Products in the event. This is used by at least Blueshift to manage campaigns. Should contain the following properties:
   *
   * product\_id
   * sku
   * name
   * price
   * category (aka: Reporting Product Category)
   * product\_line (aka: Reporting Product Line)
   *
   * | Rule | Value |
   * |---|---|
   * | Item Type | object |
   */
  products?: {
    [k: string]: unknown;
  }[];
  /**
   * String representing the shipping the method chosen
   */
  shipping_method?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  shipping_price?: number;
  /**
   * * amount
   *
   * * method_title
   *
   * * estimated*\_*arrival_time
   *
   * | Rule | Value |
   * |---|---|
   * | Item Type | object |
   */
  shipping_properties?: {
    [k: string]: unknown;
  }[];
  /**
   * Number representing a step in the checkout process: 1-Viewed Cart; 2-Shipping; 3-Billing; 4-Review
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  step: number;
  /**
   * True/false indicated if the step was auto-completed (due to a previous order) or if the customer actually completed the step.
   */
  step_auto_completed: boolean;
  /**
   * Text representing a step in the checkout process: Viewed Cart, Shipping, Billing, Review
   */
  step_name: string;
  /**
   * Order total before discounts, taxes and shipping; essentially gross product revenue
   * [sales_order.base_subtotal]
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  subtotal?: number;
  /**
   * Total tax associated with the transaction [sales_order.base_tax_amount]
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  tax?: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  total?: number;
}

export interface CheckoutStepViewedProperties {
  /**
   * Editor version (1 or 2). Required for any events in Editor
   */
  au_project_version?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  base_total?: number;
  /**
   * [sales_order.quote_id]
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  cart_id?: number;
  /**
   * Represents quote_id in Magento
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  checkout_id: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  discount_amount?: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  discounted_total?: number;
  /**
   * Editor minor version (e.g. 1.62.1)
   */
  editor_version?: string;
  /**
   * Is the user using a mobile device?
   */
  is_mobile_view?: boolean;
  /**
   * String representing the payment method chosen
   */
  payment_method?: string;
  /**
   * Price as displayed to the customer; in some events, such as Product Viewed and Product List Viewed, this will be set to the Lowest Price since price can change based on options selected
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  price?: number;
  /**
   * Products in the event. This is used by at least Blueshift to manage campaigns. Should contain the following properties:
   *
   * product\_id
   * sku
   * name
   * price
   * category (aka: Reporting Product Category)
   * product\_line (aka: Reporting Product Line)
   *
   * | Rule | Value |
   * |---|---|
   * | Item Type | object |
   */
  products?: {
    [k: string]: unknown;
  }[];
  /**
   * String representing the shipping the method chosen
   */
  shipping_method?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  shipping_price?: number;
  /**
   * * amount
   *
   * * method_title
   *
   * * estimated*\_*arrival_time
   *
   * | Rule | Value |
   * |---|---|
   * | Item Type | object |
   */
  shipping_properties?: {
    [k: string]: unknown;
  }[];
  /**
   * Number representing a step in the checkout process: 1-Viewed Cart; 2-Shipping; 3-Billing; 4-Review
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  step: number;
  /**
   * True/false indicated if the step was auto-completed (due to a previous order) or if the customer actually completed the step.
   */
  step_auto_completed: boolean;
  /**
   * Text representing a step in the checkout process: Viewed Cart, Shipping, Billing, Review
   */
  step_name: string;
  /**
   * Order total before discounts, taxes and shipping; essentially gross product revenue
   * [sales_order.base_subtotal]
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  subtotal?: number;
  /**
   * Total tax associated with the transaction [sales_order.base_tax_amount]
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  tax?: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  total?: number;
}

export interface ClpEmptyResultsProperties {
  /**
   * What filters has the user selected
   */
  filters_selected?: {
    [k: string]: unknown;
  };
}

export interface CLPLinkClickedProperties {
  /**
   * Which card in the CLP product grid this event belongs to. The first product is card number 1 and the rest follow sequentially
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   * | Min Value | 1 |
   */
  card_number?: number;
  /**
   * Which link was clicked on the CLP:
   *
   * * card - The user clicked on one of the product links that includes an image
   *
   * * text - The user clicked on a text link (no image)
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | card, text |
   */
  link_type: "card" | "text";
  /**
   * The page of results that the link clicked is on
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  page_number: number;
  /**
   * The product that the user clicked on
   */
  product_name: string;
}

export interface CLPLinkSwipeProperties {
  /**
   * Which card in the CLP product grid this event belongs to. The first product is card number 1 and the rest follow sequentially
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   * | Min Value | 1 |
   */
  card_number?: number;
  /**
   * The product that the user clicked on
   */
  product_name: string;
}

export interface ComponentLoadedProperties {
  /**
   * [sales_order.quote_id]
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  cart_id?: number;
  component_name: string;
  /**
   * The customer's email address
   */
  email?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  load_time: number;
}

export interface ConsentDefinedProperties {
  /**
   * Editor version (1 or 2). Required for any events in Editor
   */
  au_project_version?: string;
  /**
   * INACTIVE
   */
  au_split_editorV2_books?: string;
  au_split_editorV2_feature_flag_autofill?: boolean;
  au_split_editorV2_guestbookset?: string;
  /**
   * Split for Spread Books testing
   */
  au_split_editorV2_spread_books?: string;
  /**
   * Property containing the split treatment for whether the Google log in/sign up buttons are shown to the user
   */
  au_split_feature_flag_google_sign_in?: boolean;
  /**
   * Property containing the split treatment for the new product search experience at commerce
   */
  au_split_feature_flag_product_search?: boolean;
  "au_split_featureflag-chooseimagemodalflow"?: boolean;
  consent_status: boolean;
  /**
   * Editor minor version (e.g. 1.62.1)
   */
  editor_version?: string;
  /**
   * Is the user using a mobile device?
   */
  is_mobile_view?: boolean;
}

export interface ConsentPreferencesOpenedProperties {
  /**
   * Editor version (1 or 2). Required for any events in Editor
   */
  au_project_version?: string;
  /**
   * INACTIVE
   */
  au_split_editorV2_books?: string;
  au_split_editorV2_feature_flag_autofill?: boolean;
  au_split_editorV2_guestbookset?: string;
  /**
   * Split for Spread Books testing
   */
  au_split_editorV2_spread_books?: string;
  /**
   * Property containing the split treatment for whether the Google log in/sign up buttons are shown to the user
   */
  au_split_feature_flag_google_sign_in?: boolean;
  /**
   * Property containing the split treatment for the new product search experience at commerce
   */
  au_split_feature_flag_product_search?: boolean;
  "au_split_featureflag-chooseimagemodalflow"?: boolean;
  /**
   * Editor minor version (e.g. 1.62.1)
   */
  editor_version?: string;
  /**
   * Is the user using a mobile device?
   */
  is_mobile_view?: boolean;
}

export interface CTAImpressionProperties {
  /**
   * The reporting product category in Magento
   */
  category: string;
  ecomm_prodid?: string;
  /**
   * True if the product can be customized in editor; false if it goes straight to the cart
   */
  is_customizable_product?: boolean;
  /**
   * Product name for the parent product
   */
  name: string;
  /**
   * Price as displayed to the customer; in some events, such as Product Viewed and Product List Viewed, this will be set to the Lowest Price since price can change based on options selected
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  price?: number;
  /**
   * The product_id for the parent product
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  product_id: number;
  /**
   * The reporting product line in Magento
   */
  product_line: string;
  /**
   * The reporting product type in Magento
   */
  product_type?: string;
  /**
   * Products in the event. This is used by at least Blueshift to manage campaigns. Should contain the following properties:
   *
   * product\_id
   * sku
   * name
   * price
   * category (aka: Reporting Product Category)
   * product\_line (aka: Reporting Product Line)
   *
   * | Rule | Value |
   * |---|---|
   * | Item Type | object |
   */
  products?: {
    [k: string]: unknown;
  }[];
  /**
   * SKU for the parent product
   */
  sku: string;
}

export interface CTAPreviewExpandedProperties {
  /**
   * Editor version (1 or 2). Required for any events in Editor
   */
  au_project_version?: string;
  /**
   * INACTIVE
   */
  au_split_editorV2_books?: string;
  au_split_editorV2_feature_flag_autofill?: boolean;
  au_split_editorV2_guestbookset?: string;
  /**
   * Split for Spread Books testing
   */
  au_split_editorV2_spread_books?: string;
  /**
   * Property containing the split treatment for whether the Google log in/sign up buttons are shown to the user
   */
  au_split_feature_flag_google_sign_in?: boolean;
  /**
   * Property containing the split treatment for the new product search experience at commerce
   */
  au_split_feature_flag_product_search?: boolean;
  "au_split_featureflag-chooseimagemodalflow"?: boolean;
  /**
   * The reporting product category in Magento
   */
  category: string;
  ecomm_prodid?: string;
  /**
   * Editor minor version (e.g. 1.62.1)
   */
  editor_version?: string;
  /**
   * True if the product can be customized in editor; false if it goes straight to the cart
   */
  is_customizable_product?: boolean;
  /**
   * Is the user using a mobile device?
   */
  is_mobile_view?: boolean;
  /**
   * Product name for the parent product
   */
  name: string;
  /**
   * Price as displayed to the customer; in some events, such as Product Viewed and Product List Viewed, this will be set to the Lowest Price since price can change based on options selected
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  price?: number;
  /**
   * The product_id for the parent product
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  product_id: number;
  /**
   * The reporting product line in Magento
   */
  product_line: string;
  /**
   * The reporting product type in Magento
   */
  product_type?: string;
  /**
   * Products in the event. This is used by at least Blueshift to manage campaigns. Should contain the following properties:
   *
   * product\_id
   * sku
   * name
   * price
   * category (aka: Reporting Product Category)
   * product\_line (aka: Reporting Product Line)
   *
   * | Rule | Value |
   * |---|---|
   * | Item Type | object |
   */
  products?: {
    [k: string]: unknown;
  }[];
  /**
   * SKU for the parent product
   */
  sku: string;
}

export interface DesignItLaterClickedProperties {
  /**
   * The customer's email address
   */
  email?: string;
  is_logged_in: boolean;
  /**
   * The product_id for the parent product
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  product_id: number;
}

export interface DesignItLaterEmailSubmittedProperties {
  pdp_image?: string;
  pdp_url: string;
}

export interface DSButtonClickedProperties {
  /**
   * The reporting product category in Magento
   */
  category: string;
  ecomm_prodid?: string;
  /**
   * True if the product can be customized in editor; false if it goes straight to the cart
   */
  is_customizable_product?: boolean;
  /**
   * Product name for the parent product
   */
  name: string;
  /**
   * Price as displayed to the customer; in some events, such as Product Viewed and Product List Viewed, this will be set to the Lowest Price since price can change based on options selected
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  price?: number;
  /**
   * The product_id for the parent product
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  product_id: number;
  /**
   * The reporting product line in Magento
   */
  product_line: string;
  /**
   * The reporting product type in Magento
   */
  product_type?: string;
  /**
   * Products in the event. This is used by at least Blueshift to manage campaigns. Should contain the following properties:
   *
   * product\_id
   * sku
   * name
   * price
   * category (aka: Reporting Product Category)
   * product\_line (aka: Reporting Product Line)
   *
   * | Rule | Value |
   * |---|---|
   * | Item Type | object |
   */
  products?: {
    [k: string]: unknown;
  }[];
  /**
   * SKU for the parent product
   */
  sku: string;
}

export interface EmailSubscribedProperties {
  customer_id: string;
  /**
   * The customer's email address
   */
  email?: string;
  last_updated: string;
  location: string;
  subscription: string;
  pdpUrl?: string;
  pdpImg?: string;
}

export interface FilterDeselectedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Item Type | object |
   */
  applied_filters?: {
    [k: string]: unknown;
  }[];
  filter_option?: string;
  filter_value?: string;
}

export interface FilterSelectedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Item Type | object |
   */
  applied_filters?: {
    [k: string]: unknown;
  }[];
  filter_option?: string;
  filter_value?: string;
}

export interface FirstPurchaseProperties {
  /**
   * [sales_order.increment_id]
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  order_id: number;
  /**
   * Order total before discounts, taxes and shipping; essentially gross product revenue
   * [sales_order.base_subtotal]
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  subtotal?: number;
}

export interface ImageUploadAttemptedProperties {
  /**
   * Is the user using a mobile device?
   */
  is_mobile_view?: boolean;
  source?: string;
  upload_selected_count: string;
  upload_selected_extensions: string;
  upload_selected_sizes: string;
  /**
   * Application from which this image was uploaded (ex: editor-v2)
   */
  upload_source: string;
}

export interface ImageUploadCompletedProperties {
  /**
   * Is the user using a mobile device?
   */
  is_mobile_view?: boolean;
  source?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  upload_completed_count: number;
  upload_completed_extensions: string;
  upload_completed_sizes: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  upload_completed_time: number;
  /**
   * Application from which this image was uploaded (ex: editor-v2)
   */
  upload_source: string;
}

export interface ImageUploadFailedProperties {
  /**
   * Is the user using a mobile device?
   */
  is_mobile_view?: boolean;
  source?: string;
  upload_accepted_count: string;
  upload_accepted_sizes: string;
  upload_rejected_count: string;
  upload_rejected_error_codes: string;
  upload_rejected_extensions: string;
  upload_rejected_sizes: string;
  /**
   * Application from which this image was uploaded (ex: editor-v2)
   */
  upload_source: string;
}

export interface LoginAttemptedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | Google, Email |
   */
  login_method?: "Google" | "Email";
}

export interface LoginCompletedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | New, Existing, Unknown |
   */
  account_type?: "New" | "Existing" | "Unknown";
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | Google, Email |
   */
  login_method?: "Google" | "Email";
}

export interface LoginStartedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | Checkout, Project, Nav |
   */
  login_type?: "Checkout" | "Project" | "Nav";
}

export interface MyProjectsPageViewedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  page_count: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  page_version?: number;
}

export interface NavLinkClickedProperties {
  click_zone: string;
  link: string;
  nav_header: string;
  nav_section?: string;
  nav_subsection?: string;
  navigation_target: string;
}

export interface NewCardAddedProperties {
  /**
   * [sales_order.quote_id]
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  cart_id?: number;
  /**
   * Shipping options that users are presented with on the checkout page
   *
   * | Rule | Value |
   * |---|---|
   * | Item Type | object |
   */
  shipping_options?: {
    [k: string]: unknown;
  }[];
}

export interface OptionPreviewExpandedProperties {
  /**
   * The reporting product category in Magento
   */
  category: string;
  ecomm_prodid?: string;
  /**
   * True if the product can be customized in editor; false if it goes straight to the cart
   */
  is_customizable_product?: boolean;
  /**
   * Product name for the parent product
   */
  name: string;
  /**
   * The product attribute that the user has selected
   */
  option_attribute: string;
  /**
   * Price as displayed to the customer; in some events, such as Product Viewed and Product List Viewed, this will be set to the Lowest Price since price can change based on options selected
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  price?: number;
  /**
   * The product_id for the parent product
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  product_id: number;
  /**
   * The reporting product line in Magento
   */
  product_line: string;
  /**
   * The reporting product type in Magento
   */
  product_type?: string;
  /**
   * Products in the event. This is used by at least Blueshift to manage campaigns. Should contain the following properties:
   *
   * product\_id
   * sku
   * name
   * price
   * category (aka: Reporting Product Category)
   * product\_line (aka: Reporting Product Line)
   *
   * | Rule | Value |
   * |---|---|
   * | Item Type | object |
   */
  products?: {
    [k: string]: unknown;
  }[];
  /**
   * SKU for the parent product
   */
  sku: string;
}

export interface OrderCompletedProperties {
  /**
   * List of AB tests in this format: upload_experience = "new_experience"
   */
  ab_test?: {
    [k: string]: unknown;
  };
  /**
   * Editor version (1 or 2). Required for any events in Editor
   */
  au_project_version?: string;
  /**
   * INACTIVE
   */
  au_split_editorV2_books?: string;
  au_split_editorV2_feature_flag_autofill?: boolean;
  au_split_editorV2_guestbookset?: string;
  /**
   * Split for Spread Books testing
   */
  au_split_editorV2_spread_books?: string;
  /**
   * Property containing the split treatment for whether the Google log in/sign up buttons are shown to the user
   */
  au_split_feature_flag_google_sign_in?: boolean;
  /**
   * Property containing the split treatment for the new product search experience at commerce
   */
  au_split_feature_flag_product_search?: boolean;
  "au_split_featureflag-chooseimagemodalflow"?: boolean;
  billing_country: string;
  billing_phone: string;
  billing_state: string;
  billing_zip: string;
  /**
   * [sales_order.quote_id]
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  cart_id?: number;
  /**
   * Transaction coupon redeemed with the transaction [sales_order.coupon_code]
   */
  coupon?: string;
  /**
   * Currency code associated with the transaction (see https://support.google.com/analytics/answer/6205902#supported-currencies); [sales_order.base_currency_code]
   */
  currency: string;
  customer_ip?: string;
  /**
   * Total discount associated with the transaction [-1 * sales_order.base_discount_amount]
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  discount: number;
  /**
   * Editor minor version (e.g. 1.62.1)
   */
  editor_version?: string;
  /**
   * The customer's email address
   */
  email?: string;
  /**
   * User is bucked to see the Amazon Pay widget
   */
  has_amazonpay?: boolean;
  /**
   * Is the user using a mobile device?
   */
  is_mobile_view?: boolean;
  /**
   * [sales_order.increment_id]
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  order_id: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  orderId?: number;
  /**
   * payment method used in the order
   */
  payment_method?: string;
  /**
   * Products in the event. This is used by at least Blueshift to manage campaigns. Should contain the following properties:
   *
   * product\_id
   * sku
   * name
   * price
   * category (aka: Reporting Product Category)
   * product\_line (aka: Reporting Product Line)
   *
   * | Rule | Value |
   * |---|---|
   * | Item Type | object |
   */
  products?: {
    [k: string]: unknown;
  }[];
  repeat?: boolean;
  /**
   * Revenue ($) associated with the transaction (excluding tax) [sales_order.base_grand_total - sales_order.base_tax_amount]
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  revenue: number;
  /**
   * Shipping revenue associated with the transaction [sales_order.base_shipping_amount - sales_order.base_shipping_discount_amount]
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  shipping: number;
  /**
   * Order total before discounts, taxes and shipping; essentially gross product revenue
   * [sales_order.base_subtotal]
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  subtotal?: number;
  /**
   * Total tax associated with the transaction [sales_order.base_tax_amount]
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  tax?: number;
}

export interface OrderItemCompletedProperties {
  /**
   * List of AB tests in this format: upload_experience = "new_experience"
   */
  ab_test?: {
    [k: string]: unknown;
  };
  /**
   * Editor version (1 or 2). Required for any events in Editor
   */
  au_project_version?: string;
  /**
   * INACTIVE
   */
  au_split_editorV2_books?: string;
  au_split_editorV2_feature_flag_autofill?: boolean;
  au_split_editorV2_guestbookset?: string;
  /**
   * Split for Spread Books testing
   */
  au_split_editorV2_spread_books?: string;
  /**
   * Property containing the split treatment for whether the Google log in/sign up buttons are shown to the user
   */
  au_split_feature_flag_google_sign_in?: boolean;
  /**
   * Property containing the split treatment for the new product search experience at commerce
   */
  au_split_feature_flag_product_search?: boolean;
  "au_split_featureflag-chooseimagemodalflow"?: boolean;
  /**
   * Represents quote_id in Magento
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  cart_id?: number;
  /**
   * The reporting product category in Magento
   */
  category: string;
  ecomm_prodid?: string;
  /**
   * Editor minor version (e.g. 1.62.1)
   */
  editor_version?: string;
  /**
   * True if the product can be customized in editor; false if it goes straight to the cart
   */
  is_customizable_product?: boolean;
  /**
   * Is the user using a mobile device?
   */
  is_mobile_view?: boolean;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  item_id?: number;
  /**
   * Product name for the parent product
   */
  name: string;
  /**
   * Magento increment_id
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  order_id: number;
  /**
   * Price as displayed to the customer; in some events, such as Product Viewed and Product List Viewed, this will be set to the Lowest Price since price can change based on options selected
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  price?: number;
  /**
   * The product_id for the parent product
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  product_id: number;
  /**
   * The reporting product line in Magento
   */
  product_line: string;
  /**
   * The reporting product type in Magento
   */
  product_type?: string;
  /**
   * Products in the event. This is used by at least Blueshift to manage campaigns. Should contain the following properties:
   *
   * product\_id
   * sku
   * name
   * price
   * category (aka: Reporting Product Category)
   * product\_line (aka: Reporting Product Line)
   *
   * | Rule | Value |
   * |---|---|
   * | Item Type | object |
   */
  products?: {
    [k: string]: unknown;
  }[];
  /**
   * Quantity of the item purchased; for cards, a pack of 100 should be considered quantity of 1.
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  quantity: number;
  repeat?: boolean;
  /**
   * Revenue ($) associated with the transaction (excluding tax) \[sales_order.base_grand_total - sales_order.base_tax_amount\]
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  revenue: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  row_total?: number;
  /**
   * SKU for the parent product
   */
  sku: string;
}

export interface PageViewedProperties {
  /**
   * Home, Floating Picture Frame, Shopping Cart, etc.
   */
  page_name: string;
  /**
   * Product Description Page, Category Listing Page, My Account, Checkout, HomePage
   */
  page_type: string;
}

export interface PaymentMethodAtCheckoutProperties {
  /**
   * String representing the payment method chosen
   */
  payment_method?: string;
}

export interface PaymentMethodChangedProperties {
  /**
   * [sales_order.quote_id]
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  cart_id?: number;
  /**
   * String representing the payment method chosen
   */
  payment_method?: string;
  /**
   * Shipping options that users are presented with on the checkout page
   *
   * | Rule | Value |
   * |---|---|
   * | Item Type | object |
   */
  shipping_options?: {
    [k: string]: unknown;
  }[];
}

export interface PDPCTAClickedProperties {
  /**
   * Editor version (1 or 2). Required for any events in Editor
   */
  au_project_version?: string;
  /**
   * INACTIVE
   */
  au_split_editorV2_books?: string;
  au_split_editorV2_feature_flag_autofill?: boolean;
  au_split_editorV2_guestbookset?: string;
  /**
   * Split for Spread Books testing
   */
  au_split_editorV2_spread_books?: string;
  /**
   * Property containing the split treatment for whether the Google log in/sign up buttons are shown to the user
   */
  au_split_feature_flag_google_sign_in?: boolean;
  /**
   * Property containing the split treatment for the new product search experience at commerce
   */
  au_split_feature_flag_product_search?: boolean;
  "au_split_featureflag-chooseimagemodalflow"?: boolean;
  /**
   * The reporting product category in Magento
   */
  category: string;
  ecomm_prodid?: string;
  /**
   * Editor minor version (e.g. 1.62.1)
   */
  editor_version?: string;
  /**
   * True if the product can be customized in editor; false if it goes straight to the cart
   */
  is_customizable_product?: boolean;
  /**
   * Is the user using a mobile device?
   */
  is_mobile_view?: boolean;
  /**
   * Product name for the parent product
   */
  name: string;
  /**
   * True if all relevant product options were selected and the user was sent to the next page
   */
  options_complete: boolean;
  /**
   * Price as displayed to the customer; in some events, such as Product Viewed and Product List Viewed, this will be set to the Lowest Price since price can change based on options selected
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  price?: number;
  /**
   * The product_id for the parent product
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  product_id: number;
  /**
   * The reporting product line in Magento
   */
  product_line: string;
  /**
   * The reporting product type in Magento
   */
  product_type?: string;
  /**
   * Products in the event. This is used by at least Blueshift to manage campaigns. Should contain the following properties:
   *
   * product\_id
   * sku
   * name
   * price
   * category (aka: Reporting Product Category)
   * product\_line (aka: Reporting Product Line)
   *
   * | Rule | Value |
   * |---|---|
   * | Item Type | object |
   */
  products?: {
    [k: string]: unknown;
  }[];
  /**
   * SKU for the parent product
   */
  sku: string;
}

export interface PDPOptionClickedProperties {
  /**
   * The reporting product category in Magento
   */
  category: string;
  ecomm_prodid?: string;
  /**
   * True if the product can be customized in editor; false if it goes straight to the cart
   */
  is_customizable_product?: boolean;
  /**
   * Product name for the parent product
   */
  name: string;
  /**
   * The product attribute that the user has selected
   */
  option_attribute: string;
  /**
   * The display name for the product attribute that the user has selected. This is provided to give a better idea what the user saw when selecting the option, while the attribute property is a more consistent, technical identifier.
   */
  option_display_name: string;
  /**
   * The value of the attribute that the user has selected
   */
  option_value: string;
  /**
   * Price as displayed to the customer; in some events, such as Product Viewed and Product List Viewed, this will be set to the Lowest Price since price can change based on options selected
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  price?: number;
  /**
   * The product_id for the parent product
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  product_id: number;
  /**
   * The reporting product line in Magento
   */
  product_line: string;
  /**
   * The reporting product type in Magento
   */
  product_type?: string;
  /**
   * Products in the event. This is used by at least Blueshift to manage campaigns. Should contain the following properties:
   *
   * product\_id
   * sku
   * name
   * price
   * category (aka: Reporting Product Category)
   * product\_line (aka: Reporting Product Line)
   *
   * | Rule | Value |
   * |---|---|
   * | Item Type | object |
   */
  products?: {
    [k: string]: unknown;
  }[];
  /**
   * SKU for the parent product
   */
  sku: string;
}

export interface ProductAddedProperties {
  /**
   * List of AB tests in this format: upload_experience = "new_experience"
   */
  ab_test?: {
    [k: string]: unknown;
  };
  /**
   * Editor version (1 or 2). Required for any events in Editor
   */
  au_project_version?: string;
  /**
   * INACTIVE
   */
  au_split_editorV2_books?: string;
  au_split_editorV2_feature_flag_autofill?: boolean;
  au_split_editorV2_guestbookset?: string;
  /**
   * Split for Spread Books testing
   */
  au_split_editorV2_spread_books?: string;
  /**
   * Property containing the split treatment for whether the Google log in/sign up buttons are shown to the user
   */
  au_split_feature_flag_google_sign_in?: boolean;
  /**
   * Property containing the split treatment for the new product search experience at commerce
   */
  au_split_feature_flag_product_search?: boolean;
  "au_split_featureflag-chooseimagemodalflow"?: boolean;
  /**
   * The reporting product category in Magento
   */
  category: string;
  customer_ip?: string;
  ecomm_prodid?: string;
  /**
   * Editor minor version (e.g. 1.62.1)
   */
  editor_version?: string;
  /**
   * The customer's email address
   */
  email?: string;
  /**
   * True if the product can be customized in editor; false if it goes straight to the cart
   */
  is_customizable_product?: boolean;
  /**
   * Is the user using a mobile device?
   */
  is_mobile_view?: boolean;
  location: string;
  /**
   * Product name for the parent product
   */
  name: string;
  /**
   * Price as displayed to the customer; in some events, such as Product Viewed and Product List Viewed, this will be set to the Lowest Price since price can change based on options selected
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  price?: number;
  /**
   * The product_id for the parent product
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  product_id: number;
  /**
   * The reporting product line in Magento
   */
  product_line: string;
  /**
   * The reporting product type in Magento
   */
  product_type?: string;
  /**
   * Products in the event. This is used by at least Blueshift to manage campaigns. Should contain the following properties:
   *
   * product\_id
   * sku
   * name
   * price
   * category (aka: Reporting Product Category)
   * product\_line (aka: Reporting Product Line)
   *
   * | Rule | Value |
   * |---|---|
   * | Item Type | object |
   */
  products?: {
    [k: string]: unknown;
  }[];
  project_id?: string;
  /**
   * SKU for the parent product
   */
  sku: string;
}

export interface ProductAssistantExpandClickedProperties {
  current_url: string;
}

export interface ProductAssistantLinkClickedProperties {
  current_url: string;
  link: string;
}

export interface ProductAssistantMessageSentProperties {
  current_url: string;
  user_message: string;
}

export interface ProductAssistantOpenedProperties {
  current_url: string;
}

export interface ProductAssistantResetClickedProperties {
  current_url: string;
}

export interface ProductAssistantSampleQuestionArrowClickedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | left, right |
   */
  arrow: "left" | "right";
  current_url: string;
}

export interface ProductAssistantSampleQuestionClickedProperties {
  current_url: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  index: number;
  sample_question: string;
}

export interface ProductListViewedProperties {
  /**
   * Product category being viewed (e.g. books). Use / as a delimiter to specify up to 5-levels of hierarchy (e.g. Apparel/Men/T-Shirts).
   */
  category: string;
  /**
   * Products displayed in the product list Should contain the following properties:
   *
   * product_id
   * sku
   * name
   * price
   * quantity
   * category (aka: Reporting Product Category)
   * product_line (aka: Reporting Product Line)
   * position (position in the product list - ex. 3)
   * url (URL of the product page)
   * image_url (Image url of the product)
   *
   * | Rule | Value |
   * |---|---|
   * | Item Type | object |
   */
  products: {
    [k: string]: unknown;
  }[];
}

export interface ProductQuantityChangedProperties {
  /**
   * [sales_order.quote_id]
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  cart_id?: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  new_quantity: number;
  /**
   * The product_id for the parent product
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  product_id: number;
  /**
   * SKU for the parent product
   */
  sku: string;
}

export interface ProductRemovedProperties {
  /**
   * [sales_order.quote_id]
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  cart_id?: number;
  /**
   * Price as displayed to the customer; in some events, such as Product Viewed and Product List Viewed, this will be set to the Lowest Price since price can change based on options selected
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  price?: number;
  /**
   * The product_id for the parent product
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  product_id: number;
  /**
   * SKU for the parent product
   */
  sku: string;
}

export interface ProductViewedProperties {
  /**
   * The reporting product category in Magento
   */
  category: string;
  ecomm_prodid?: string;
  /**
   * True if the product can be customized in editor; false if it goes straight to the cart
   */
  is_customizable_product?: boolean;
  /**
   * Product name for the parent product
   */
  name: string;
  /**
   * Price as displayed to the customer; in some events, such as Product Viewed and Product List Viewed, this will be set to the Lowest Price since price can change based on options selected
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  price?: number;
  /**
   * The product_id for the parent product
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  product_id: number;
  /**
   * The reporting product line in Magento
   */
  product_line: string;
  /**
   * The reporting product type in Magento
   */
  product_type?: string;
  /**
   * Products in the event. This is used by at least Blueshift to manage campaigns. Should contain the following properties:
   *
   * product\_id
   * sku
   * name
   * price
   * category (aka: Reporting Product Category)
   * product\_line (aka: Reporting Product Line)
   *
   * | Rule | Value |
   * |---|---|
   * | Item Type | object |
   */
  products?: {
    [k: string]: unknown;
  }[];
  /**
   * SKU for the parent product
   */
  sku: string;
}

export interface ProjectClickedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | card, kabob |
   */
  click_type: "card" | "kabob";
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  page_version?: number;
}

export interface ProjectDeletedProperties {
  /**
   * The reporting product category in Magento
   */
  category: string;
  ecomm_prodid?: string;
  /**
   * True if the product can be customized in editor; false if it goes straight to the cart
   */
  is_customizable_product?: boolean;
  /**
   * Product name for the parent product
   */
  name: string;
  /**
   * Price as displayed to the customer; in some events, such as Product Viewed and Product List Viewed, this will be set to the Lowest Price since price can change based on options selected
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  price?: number;
  /**
   * The product_id for the parent product
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  product_id: number;
  /**
   * The reporting product line in Magento
   */
  product_line: string;
  /**
   * The reporting product type in Magento
   */
  product_type?: string;
  /**
   * Products in the event. This is used by at least Blueshift to manage campaigns. Should contain the following properties:
   *
   * product\_id
   * sku
   * name
   * price
   * category (aka: Reporting Product Category)
   * product\_line (aka: Reporting Product Line)
   *
   * | Rule | Value |
   * |---|---|
   * | Item Type | object |
   */
  products?: {
    [k: string]: unknown;
  }[];
  project_id: string;
  /**
   * SKU for the parent product
   */
  sku: string;
}

export interface ProjectDuplicatedProperties {
  /**
   * The reporting product category in Magento
   */
  category: string;
  ecomm_prodid?: string;
  /**
   * True if the product can be customized in editor; false if it goes straight to the cart
   */
  is_customizable_product?: boolean;
  /**
   * Product name for the parent product
   */
  name: string;
  /**
   * Price as displayed to the customer; in some events, such as Product Viewed and Product List Viewed, this will be set to the Lowest Price since price can change based on options selected
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  price?: number;
  /**
   * The product_id for the parent product
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  product_id: number;
  /**
   * The reporting product line in Magento
   */
  product_line: string;
  /**
   * The reporting product type in Magento
   */
  product_type?: string;
  /**
   * Products in the event. This is used by at least Blueshift to manage campaigns. Should contain the following properties:
   *
   * product\_id
   * sku
   * name
   * price
   * category (aka: Reporting Product Category)
   * product\_line (aka: Reporting Product Line)
   *
   * | Rule | Value |
   * |---|---|
   * | Item Type | object |
   */
  products?: {
    [k: string]: unknown;
  }[];
  project_id: string;
  /**
   * SKU for the parent product
   */
  sku: string;
}

export interface ProjectEditedProperties {
  /**
   * The reporting product category in Magento
   */
  category: string;
  ecomm_prodid?: string;
  /**
   * True if the product can be customized in editor; false if it goes straight to the cart
   */
  is_customizable_product?: boolean;
  /**
   * Product name for the parent product
   */
  name: string;
  /**
   * Price as displayed to the customer; in some events, such as Product Viewed and Product List Viewed, this will be set to the Lowest Price since price can change based on options selected
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  price?: number;
  /**
   * The product_id for the parent product
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  product_id: number;
  /**
   * The reporting product line in Magento
   */
  product_line: string;
  /**
   * The reporting product type in Magento
   */
  product_type?: string;
  /**
   * Products in the event. This is used by at least Blueshift to manage campaigns. Should contain the following properties:
   *
   * product\_id
   * sku
   * name
   * price
   * category (aka: Reporting Product Category)
   * product\_line (aka: Reporting Product Line)
   *
   * | Rule | Value |
   * |---|---|
   * | Item Type | object |
   */
  products?: {
    [k: string]: unknown;
  }[];
  project_id: string;
  /**
   * SKU for the parent product
   */
  sku: string;
}

export interface ProjectInfoViewedProperties {
  project_info?: string;
}

export interface ReturnToProjectClickedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | Continue, All projects |
   */
  click_type: "Continue" | "All projects";
}

export interface SearchResultSelectedProperties {
  /**
   * Property result term captures what the user clicked on
   */
  result_term: string;
  /**
   * Property search term captures what the user had entered into the field when they searched
   */
  search_term: string;
}

export interface SplitTreatmentReceivedProperties {
  /**
   * The key we give to customers that aren't logged in
   */
  split_anonymous_key?: string;
  split_name: string;
  split_treatment: string;
}

export interface VisualNavClickedProperties {
  filter_option?: string;
  filter_value?: string;
  subcategory_name: string;
}

export class AccountCreateStarted implements Event {
  name = 'Account Create Started';
  id = '85d7c2ed-2382-4fea-beb7-935dc4f8d042';
  version = '1.0.0';
}

export class AccountCreated implements Event {
  name = 'Account Created';
  id = '9499caed-19f2-4505-92fb-7827df9fea38';
  version = '2.0.0';

  constructor(
    public properties: AccountCreatedProperties,
  ) {}
}

export class ApplyPromoCode implements Event {
  name = 'Apply Promo Code';
  id = 'a7eb16cf-63c5-471d-9e21-57dbf4558d18';
  version = '1.0.0';

  constructor(
    public properties: ApplyPromoCodeProperties,
  ) {}
}

export class ApplyPromoCodeError implements Event {
  name = 'Apply Promo Code Error';
  id = 'c3a6c9ff-ae38-4a4c-a8c9-83d8c619aab5';
  version = '1.0.0';

  constructor(
    public properties: ApplyPromoCodeErrorProperties,
  ) {}
}

export class AssetClicked implements Event {
  name = 'Asset Clicked';
  id = '3e21d920-35b3-40ba-a936-4c2243bce93e';
  version = '1.0.0';

  constructor(
    public properties: AssetClickedProperties,
  ) {}
}

export class CartPageTotalLoadTime implements Event {
  name = 'Cart page total load time';
  id = 'ba268543-2b08-4900-9396-c5db24a0247c';
  version = '1.0.0';

  constructor(
    public properties: CartPageTotalLoadTimeProperties,
  ) {}
}

export class CartViewed implements Event {
  name = 'Cart Viewed';
  id = 'ffad5f72-647a-4652-b70c-4091bf1e4a69';
  version = '2.0.0';

  constructor(
    public properties: CartViewedProperties,
  ) {}
}

export class CheckoutError implements Event {
  name = 'Checkout Error';
  id = 'a97544f8-fde5-4983-83f4-30404658f2b5';
  version = '1.0.0';

  constructor(
    public properties: CheckoutErrorProperties,
  ) {}
}

export class CheckoutPageTotalLoadTime implements Event {
  name = 'Checkout page total load time';
  id = '51b3c6cc-2367-4ae7-b9d9-7c1ae9efd4c6';
  version = '1.0.0';

  constructor(
    public properties: CheckoutPageTotalLoadTimeProperties,
  ) {}
}

export class CheckoutStarted implements Event {
  name = 'Checkout Started';
  id = '442ccde1-2f75-42be-9c0e-9d41bdfe5e6c';
  version = '1.0.1';

  constructor(
    public properties: CheckoutStartedProperties,
  ) {}
}

export class CheckoutStepCompleted implements Event {
  name = 'Checkout Step Completed';
  id = '7ac85dec-8534-4cc6-9cc8-c3fd10cd8ac3';
  version = '1.0.1';

  constructor(
    public properties: CheckoutStepCompletedProperties,
  ) {}
}

export class CheckoutStepViewed implements Event {
  name = 'Checkout Step Viewed';
  id = '93f35b0c-b5b0-46b0-89bb-da33bbfee4e9';
  version = '1.0.1';

  constructor(
    public properties: CheckoutStepViewedProperties,
  ) {}
}

export class ClpEmptyResults implements Event {
  name = 'Clp Empty Results';
  id = '2cb54f92-001b-435d-988d-67a85080a196';
  version = '1.0.0';

  constructor(
    public properties?: ClpEmptyResultsProperties,
  ) {}
}

export class ClpLinkClicked implements Event {
  name = 'CLP Link Clicked';
  id = '32eb5a5e-9f02-4fec-8e11-7033982c0794';
  version = '1.0.1';

  constructor(
    public properties: CLPLinkClickedProperties,
  ) {}
}

export class ClpLinkSwipe implements Event {
  name = 'CLP Link Swipe';
  id = 'a2fdc1ad-8782-4964-853a-b91345a1dc12';
  version = '1.0.0';

  constructor(
    public properties: CLPLinkSwipeProperties,
  ) {}
}

export class ComponentLoaded implements Event {
  name = 'Component loaded';
  id = '17cdeef8-ce06-4b2d-9249-911e97750f46';
  version = '1.0.0';

  constructor(
    public properties: ComponentLoadedProperties,
  ) {}
}

export class ConsentDefined implements Event {
  name = 'Consent Defined';
  id = '5963366d-0f53-4ff2-881e-bfb5c52c0877';
  version = '2.0.0';

  constructor(
    public properties: ConsentDefinedProperties,
  ) {}
}

export class ConsentPreferencesOpened implements Event {
  name = 'Consent Preferences Opened';
  id = 'd3ad962d-8283-459b-9a7a-0ae684893b81';
  version = '2.0.0';

  constructor(
    public properties?: ConsentPreferencesOpenedProperties,
  ) {}
}

export class CtaImpression implements Event {
  name = 'CTA Impression';
  id = '1c2162bf-f65c-4154-b6d3-df17316d0b12';
  version = '2.0.0';

  constructor(
    public properties: CTAImpressionProperties,
  ) {}
}

export class CtaPreviewExpanded implements Event {
  name = 'CTA preview expanded';
  id = '32b2a9f1-3974-47dc-afec-0d548985abed';
  version = '2.0.0';

  constructor(
    public properties: CTAPreviewExpandedProperties,
  ) {}
}

export class DesignItLaterClicked implements Event {
  name = 'Design It Later Clicked';
  id = 'ed4827fa-d61f-4567-86c6-6802d4b90fcc';
  version = '1.0.0';

  constructor(
    public properties: DesignItLaterClickedProperties,
  ) {}
}

export class DesignItLaterEmailSubmitted implements Event {
  name = 'Design It Later Email Submitted';
  id = '4a33b0bf-e88e-4012-afd1-5a174ab3baee';
  version = '0.0.1';

  constructor(
    public properties: DesignItLaterEmailSubmittedProperties,
  ) {}
}

export class DsButtonClicked implements Event {
  name = 'DS button clicked';
  id = '99b9bbf8-8d8e-47dd-9b2f-fb740ea8927f';
  version = '1.0.0';

  constructor(
    public properties: DSButtonClickedProperties,
  ) {}
}

export class EmailSubscribed implements Event {
  name = 'Email Subscribed';
  id = 'c50c6249-6811-4ce7-a309-6ac7434851dc';
  version = '1.0.0';

  constructor(
    public properties: EmailSubscribedProperties,
  ) {}
}

export class FilterDeselected implements Event {
  name = 'Filter Deselected';
  id = 'a0ad3ab5-072f-4332-9060-872ceab814f0';
  version = '3.0.0';

  constructor(
    public properties?: FilterDeselectedProperties,
  ) {}
}

export class FilterSelected implements Event {
  name = 'Filter Selected';
  id = '0d5edd0e-539e-479a-b6cb-9503456f7952';
  version = '3.0.0';

  constructor(
    public properties?: FilterSelectedProperties,
  ) {}
}

export class FirstPurchase implements Event {
  name = 'First Purchase';
  id = 'f716f639-df9d-4672-a5ae-18ef086fa3bb';
  version = '1.0.0';

  constructor(
    public properties: FirstPurchaseProperties,
  ) {}
}

export class ImageUploadAttempted implements Event {
  name = 'Image Upload Attempted';
  id = 'b56347ff-e849-4776-91e1-6b0b41bd2f78';
  version = '1.0.0';

  constructor(
    public properties: ImageUploadAttemptedProperties,
  ) {}
}

export class ImageUploadCompleted implements Event {
  name = 'Image Upload Completed';
  id = '26b34aa4-70b8-433c-9398-c88c5b94a9d5';
  version = '1.0.0';

  constructor(
    public properties: ImageUploadCompletedProperties,
  ) {}
}

export class ImageUploadFailed implements Event {
  name = 'Image Upload Failed';
  id = 'e305b643-686d-45fc-8152-bf11db5ef7fb';
  version = '1.0.0';

  constructor(
    public properties: ImageUploadFailedProperties,
  ) {}
}

export class LoginAttempted implements Event {
  name = 'Login Attempted';
  id = '9602a322-b2cc-464f-a280-2b0b9adc33d4';
  version = '1.0.0';

  constructor(
    public properties?: LoginAttemptedProperties,
  ) {}
}

export class LoginCompleted implements Event {
  name = 'Login Completed';
  id = '89aa76b6-ebbc-467c-88ed-6412b2b516cd';
  version = '8.0.0';

  constructor(
    public properties?: LoginCompletedProperties,
  ) {}
}

export class LoginStarted implements Event {
  name = 'Login Started';
  id = 'e3a2cf15-c4fb-4164-9b6c-27c7f70de3fb';
  version = '4.0.0';

  constructor(
    public properties?: LoginStartedProperties,
  ) {}
}

export class MyProjectsPageViewed implements Event {
  name = 'My Projects Page Viewed';
  id = '7448ad6d-4842-456a-b18a-12c7daac9f09';
  version = '2.0.1';

  constructor(
    public properties: MyProjectsPageViewedProperties,
  ) {}
}

export class NavLinkClicked implements Event {
  name = 'Nav Link Clicked';
  id = '8c09a376-b008-4e40-a961-7b2f7c303ae9';
  version = '2.0.0';

  constructor(
    public properties: NavLinkClickedProperties,
  ) {}
}

export class NewCardAdded implements Event {
  name = 'New Card Added';
  id = '44753389-6efb-4845-9dd8-b6f31499d16f';
  version = '1.0.0';

  constructor(
    public properties?: NewCardAddedProperties,
  ) {}
}

export class OptionPreviewExpanded implements Event {
  name = 'Option Preview Expanded';
  id = '105bb2a5-ccaa-4fa7-9735-79ef13d2364f';
  version = '1.0.0';

  constructor(
    public properties: OptionPreviewExpandedProperties,
  ) {}
}

export class OrderCompleted implements Event {
  name = 'Order Completed';
  id = 'db11b3e7-3f74-4545-b3b0-5969ee07bbe5';
  version = '20.0.0';

  constructor(
    public properties: OrderCompletedProperties,
  ) {}
}

export class OrderItemCompleted implements Event {
  name = 'Order Item Completed';
  id = 'ec906f30-c6ff-4cc0-8d9e-c856823af905';
  version = '21.0.0';

  constructor(
    public properties: OrderItemCompletedProperties,
  ) {}
}

export class PageViewed implements Event {
  name = 'Page Viewed';
  id = 'e484fb13-be71-4393-bb4b-c3f144b90f4b';
  version = '1.0.0';

  constructor(
    public properties: PageViewedProperties,
  ) {}
}

export class PasswordResetStarted implements Event {
  name = 'Password Reset Started';
  id = 'c8bed37a-0fd2-4819-94c8-8781fc1b087e';
  version = '2.0.0';
}

export class PaymentMethodAtCheckout implements Event {
  name = 'Payment Method at Checkout';
  id = '33d8793b-a242-462a-88ff-fbed885fb03b';
  version = '1.0.0';

  constructor(
    public properties?: PaymentMethodAtCheckoutProperties,
  ) {}
}

export class PaymentMethodChanged implements Event {
  name = 'Payment Method Changed';
  id = '140a5bed-1bd2-4004-b9fb-ddcb8227ee4d';
  version = '1.0.0';

  constructor(
    public properties?: PaymentMethodChangedProperties,
  ) {}
}

export class PdpctaClicked implements Event {
  name = 'PDP CTA Clicked';
  id = 'a527e099-d255-4cb4-a4fd-25ee8b695d71';
  version = '3.0.0';

  constructor(
    public properties: PDPCTAClickedProperties,
  ) {}
}

export class PdpOptionClicked implements Event {
  name = 'PDP Option Clicked';
  id = '01cd0960-cee7-4488-8eb9-b0e97e785d21';
  version = '4.0.0';

  constructor(
    public properties: PDPOptionClickedProperties,
  ) {}
}

export class ProductAdded implements Event {
  name = 'Product Added';
  id = 'f4f28363-2440-4b09-b6df-1e260301307e';
  version = '17.0.0';

  constructor(
    public properties: ProductAddedProperties,
  ) {}
}

export class ProductAssistantExpandClicked implements Event {
  name = 'Product Assistant Expand Clicked';
  id = '4d7ddd86-fd38-4264-ba19-4b0193fc7f0f';
  version = '0.0.1';

  constructor(
    public properties: ProductAssistantExpandClickedProperties,
  ) {}
}

export class ProductAssistantLinkClicked implements Event {
  name = 'Product Assistant Link Clicked';
  id = '5630206e-d2fe-43c8-8e1b-83bfec4ca89e';
  version = '0.0.1';

  constructor(
    public properties: ProductAssistantLinkClickedProperties,
  ) {}
}

export class ProductAssistantMessageSent implements Event {
  name = 'Product Assistant Message Sent';
  id = '0b5594d1-ac92-45d7-bd91-30a15c0ca661';
  version = '0.0.1';

  constructor(
    public properties: ProductAssistantMessageSentProperties,
  ) {}
}

export class ProductAssistantOpened implements Event {
  name = 'Product Assistant Opened';
  id = 'b7f0920d-4627-49fe-b7c9-5c1d0443f450';
  version = '0.0.1';

  constructor(
    public properties: ProductAssistantOpenedProperties,
  ) {}
}

export class ProductAssistantResetClicked implements Event {
  name = 'Product Assistant Reset Clicked';
  id = '0ed22fe2-b970-40ce-9185-c2439781bedb';
  version = '0.0.1';

  constructor(
    public properties: ProductAssistantResetClickedProperties,
  ) {}
}

export class ProductAssistantSampleQuestionArrowClicked implements Event {
  name = 'Product Assistant Sample Question Arrow Clicked';
  id = '630d65a6-f14b-4b2e-9e54-481e32383ee8';
  version = '0.0.1';

  constructor(
    public properties: ProductAssistantSampleQuestionArrowClickedProperties,
  ) {}
}

export class ProductAssistantSampleQuestionClicked implements Event {
  name = 'Product Assistant Sample Question Clicked';
  id = 'b628f3aa-d9ff-43a2-829e-db40cc382277';
  version = '0.0.1';

  constructor(
    public properties: ProductAssistantSampleQuestionClickedProperties,
  ) {}
}

export class ProductListViewed implements Event {
  name = 'Product List Viewed';
  id = '17fbe6e4-3ab3-4c68-b926-8969a664926a';
  version = '1.0.0';

  constructor(
    public properties: ProductListViewedProperties,
  ) {}
}

export class ProductQuantityChanged implements Event {
  name = 'Product Quantity Changed';
  id = '16db1ac8-58f9-459e-a21c-c1f9bc706ffe';
  version = '1.0.0';

  constructor(
    public properties: ProductQuantityChangedProperties,
  ) {}
}

export class ProductRemoved implements Event {
  name = 'Product Removed';
  id = '4578e207-7d42-47ac-a1e5-e1b1f8786f8c';
  version = '1.0.0';

  constructor(
    public properties: ProductRemovedProperties,
  ) {}
}

export class ProductViewed implements Event {
  name = 'Product Viewed';
  id = '07c02bc5-4801-4c4c-ac0f-a99186cda444';
  version = '3.0.0';

  constructor(
    public properties: ProductViewedProperties,
  ) {}
}

export class ProjectClicked implements Event {
  name = 'Project Clicked';
  id = '3cde6350-1f36-402b-a785-7dbb76a82aa9';
  version = '1.0.1';

  constructor(
    public properties: ProjectClickedProperties,
  ) {}
}

export class ProjectDeleted implements Event {
  name = 'Project Deleted';
  id = '82549081-a685-43a6-a914-997feba59ac6';
  version = '2.0.0';

  constructor(
    public properties: ProjectDeletedProperties,
  ) {}
}

export class ProjectDuplicated implements Event {
  name = 'Project Duplicated';
  id = 'eeef1acd-8f37-43ba-acda-688ec9c52422';
  version = '2.0.0';

  constructor(
    public properties: ProjectDuplicatedProperties,
  ) {}
}

export class ProjectEdited implements Event {
  name = 'Project Edited';
  id = 'ef270809-efdb-4679-9ba3-ae98858b62e8';
  version = '3.0.0';

  constructor(
    public properties: ProjectEditedProperties,
  ) {}
}

export class ProjectInfoViewed implements Event {
  name = 'Project Info Viewed';
  id = '4b915c6c-9f05-48bf-bb3d-6380d1306c56';
  version = '1.0.0';

  constructor(
    public properties?: ProjectInfoViewedProperties,
  ) {}
}

export class ProjectRenamed implements Event {
  name = 'Project Renamed';
  id = '20b9f043-47f0-44e4-9d11-96848c4440f4';
  version = '1.0.0';
}

export class ReturnToProjectClicked implements Event {
  name = 'Return to Project Clicked';
  id = '55cef3bd-6c66-4b65-854b-11e7b3dd26ca';
  version = '1.0.0';

  constructor(
    public properties: ReturnToProjectClickedProperties,
  ) {}
}

export class ReturnToProjectDismissed implements Event {
  name = 'Return to Project Dismissed';
  id = 'e0152198-3980-42f2-8ab5-5118122a463c';
  version = '1.0.0';
}

export class ReturnToProjectImpression implements Event {
  name = 'Return to Project Impression';
  id = '652f7b24-da0d-4528-95a1-7f4ac45f365e';
  version = '1.0.0';
}

export class SearchResultSelected implements Event {
  name = 'Search result selected';
  id = '1bea6b06-eef2-4ce7-885a-7f068ad3687e';
  version = '2.0.0';

  constructor(
    public properties: SearchResultSelectedProperties,
  ) {}
}

export class SearchStarted implements Event {
  name = 'Search started';
  id = '83d18487-3629-417f-a5d6-7eaa8c072117';
  version = '1.0.0';
}

export class SplitTreatmentReceived implements Event {
  name = 'Split Treatment Received';
  id = 'ec6093cd-ec21-43c5-b213-ab361e3dcae5';
  version = '1.0.2';

  constructor(
    public properties: SplitTreatmentReceivedProperties,
  ) {}
}

export class VisualNavClicked implements Event {
  name = 'Visual Nav Clicked';
  id = '182ceb0b-71b8-4f05-a3d4-118c26ce88c9';
  version = '1.0.0';

  constructor(
    public properties: VisualNavClickedProperties,
  ) {}
}

// prettier-ignore
interface DestinationOptions {
  segment?: SegmentOptions;
  all?: {
    disabled?: boolean;
  };
}

export interface LoadOptions extends OptionsBase {
  /**
   * Additional context properties to add to all events.
   */
  context?: ContextProperties;
  /**
   * Analytics provider-specific configuration.
   */
  destinations?: DestinationOptions;
}

// prettier-ignore
class Itly {
  private itly: ItlyBrowser;

  constructor() {
    this.itly = new ItlyBrowser();
  }

  /**
   * Initialize the Itly SDK. Call once when your application starts.
   * @param loadOptions Configuration options to initialize the Itly SDK with.
   */
  load(loadOptions: LoadOptions = {}) {
    const {
      destinations = {} as DestinationOptions,
      plugins = [] as Plugin[],
      ...options
    } = loadOptions;

    const destinationPlugins = destinations.all && destinations.all.disabled
      ? []
      : [
        new SegmentPlugin(options.environment === 'production'
          ? 'FiAHpeHX0sUOoW4qtncLwpLmDofisVao'
          : 'xkJFNI7piCweJWstKQktvx8zmqSOxmcM',
          destinations.segment,
        ),
      ];

    this.itly.load({
      ...options,
      plugins: [
        new SchemaValidatorPlugin({
          'context': {"type":"object","properties":{"au_project_version":{"type":"string"},"au_split_editorV2_books":{"type":"string"},"au_split_editorV2_feature_flag_autofill":{"type":"boolean"},"au_split_editorV2_guestbookset":{"type":"string"},"au_split_editorV2_spread_books":{"type":"string"},"au_split_feature_flag_google_sign_in":{"type":"boolean"},"au_split_feature_flag_product_search":{"type":"boolean"},"au_split_featureflag-chooseimagemodalflow":{"type":"boolean"},"editor_version":{"type":"string"},"is_mobile_view":{"type":"boolean"}},"additionalProperties":false,"required":[]},
          'identify': {"type":"object","properties":{"email":{"type":"string"},"first_name":{"type":"string"},"last_name":{"type":"string"},"unsubscribed":{"type":"boolean"}},"additionalProperties":false,"required":[]},
          'Account Create Started': {"type":"object","properties":{},"additionalProperties":false,"required":[]},
          'Account Created': {"type":"object","properties":{"email":{"type":"string"},"user_id":{"type":"number"}},"additionalProperties":false,"required":["user_id"]},
          'Apply Promo Code': {"type":"object","properties":{"cart_id":{"type":"integer"},"promo_code":{"type":"string"}},"additionalProperties":false,"required":["promo_code"]},
          'Apply Promo Code Error': {"type":"object","properties":{"cart_id":{"type":"integer"},"promo_code":{"type":"string"},"promo_code_error":{"type":"string"}},"additionalProperties":false,"required":["promo_code","promo_code_error"]},
          'Asset Clicked': {"type":"object","properties":{"creative":{"type":"string"},"location":{"type":"string"},"navigation_target":{"type":"string"}},"additionalProperties":false,"required":["creative","location","navigation_target"]},
          'Cart page total load time': {"type":"object","properties":{"cart_id":{"type":"integer"},"email":{"type":"string"},"load_time":{"type":"number"}},"additionalProperties":false,"required":["load_time"]},
          'Cart Viewed': {"type":"object","properties":{"au_project_version":{"type":"string"},"au_split_editorV2_books":{"type":"string"},"au_split_editorV2_feature_flag_autofill":{"type":"boolean"},"au_split_editorV2_guestbookset":{"type":"string"},"au_split_editorV2_spread_books":{"type":"string"},"au_split_feature_flag_google_sign_in":{"type":"boolean"},"au_split_feature_flag_product_search":{"type":"boolean"},"au_split_featureflag-chooseimagemodalflow":{"type":"boolean"},"base_total":{"type":"number"},"cart_id":{"type":"number"},"discount_amount":{"type":"number"},"editor_version":{"type":"string"},"is_mobile_view":{"type":"boolean"},"products":{"items":{"type":"object"},"type":"array"},"shipping_price":{"type":"number"},"shipping_properties":{"items":{"type":"object"},"type":"array"},"subtotal":{"type":"number"},"tax":{"type":"number"},"total":{"type":"number"}},"additionalProperties":false,"required":["products"]},
          'Checkout Error': {"type":"object","properties":{"cart_id":{"type":"integer"},"error":{"type":"object"},"error_message":{"type":"string"}},"additionalProperties":false,"required":["error","error_message"]},
          'Checkout page total load time': {"type":"object","properties":{"cart_id":{"type":"integer"},"email":{"type":"string"},"load_time":{"type":"number"}},"additionalProperties":false,"required":["load_time"]},
          'Checkout Started': {"type":"object","properties":{"cart_id":{"type":"number"},"coupon":{"type":"string"},"currency":{"type":"string"},"products":{"items":{"type":"object"},"type":"array"},"revenue":{"type":"number"}},"additionalProperties":false,"required":["currency","products","revenue"]},
          'Checkout Step Completed': {"type":"object","properties":{"au_project_version":{"type":"string"},"base_total":{"type":"number"},"cart_id":{"type":"integer"},"checkout_id":{"type":"number"},"discount_amount":{"type":"number"},"discounted_total":{"type":"number"},"editor_version":{"type":"string"},"is_mobile_view":{"type":"boolean"},"payment_method":{"type":"string"},"price":{"type":"number"},"products":{"items":{"type":"object"},"type":"array"},"shipping_method":{"type":"string"},"shipping_price":{"type":"number"},"shipping_properties":{"items":{"type":"object"},"type":"array"},"step":{"type":"number"},"step_auto_completed":{"type":"boolean"},"step_name":{"type":"string"},"subtotal":{"type":"number"},"tax":{"type":"number"},"total":{"type":"number"}},"additionalProperties":false,"required":["checkout_id","step","step_auto_completed","step_name"]},
          'Checkout Step Viewed': {"type":"object","properties":{"au_project_version":{"type":"string"},"base_total":{"type":"number"},"cart_id":{"type":"integer"},"checkout_id":{"type":"number"},"discount_amount":{"type":"number"},"discounted_total":{"type":"number"},"editor_version":{"type":"string"},"is_mobile_view":{"type":"boolean"},"payment_method":{"type":"string"},"price":{"type":"number"},"products":{"items":{"type":"object"},"type":"array"},"shipping_method":{"type":"string"},"shipping_price":{"type":"number"},"shipping_properties":{"items":{"type":"object"},"type":"array"},"step":{"type":"number"},"step_auto_completed":{"type":"boolean"},"step_name":{"type":"string"},"subtotal":{"type":"number"},"tax":{"type":"number"},"total":{"type":"number"}},"additionalProperties":false,"required":["checkout_id","step","step_auto_completed","step_name"]},
          'Clp Empty Results': {"type":"object","properties":{"filters_selected":{"type":"object"}},"additionalProperties":false,"required":[]},
          'CLP Link Clicked': {"type":"object","properties":{"card_number":{"type":"integer","minimum":1},"link_type":{"enum":["card","text"]},"page_number":{"type":"integer"},"product_name":{"type":"string"}},"additionalProperties":false,"required":["link_type","page_number","product_name"]},
          'CLP Link Swipe': {"type":"object","properties":{"card_number":{"type":"integer","minimum":1},"product_name":{"type":"string"}},"additionalProperties":false,"required":["product_name"]},
          'Component loaded': {"type":"object","properties":{"cart_id":{"type":"integer"},"component_name":{"type":"string"},"email":{"type":"string"},"load_time":{"type":"number"}},"additionalProperties":false,"required":["component_name","load_time"]},
          'Consent Defined': {"type":"object","properties":{"au_project_version":{"type":"string"},"au_split_editorV2_books":{"type":"string"},"au_split_editorV2_feature_flag_autofill":{"type":"boolean"},"au_split_editorV2_guestbookset":{"type":"string"},"au_split_editorV2_spread_books":{"type":"string"},"au_split_feature_flag_google_sign_in":{"type":"boolean"},"au_split_feature_flag_product_search":{"type":"boolean"},"au_split_featureflag-chooseimagemodalflow":{"type":"boolean"},"consent_status":{"type":"boolean"},"editor_version":{"type":"string"},"is_mobile_view":{"type":"boolean"}},"additionalProperties":false,"required":["consent_status"]},
          'Consent Preferences Opened': {"type":"object","properties":{"au_project_version":{"type":"string"},"au_split_editorV2_books":{"type":"string"},"au_split_editorV2_feature_flag_autofill":{"type":"boolean"},"au_split_editorV2_guestbookset":{"type":"string"},"au_split_editorV2_spread_books":{"type":"string"},"au_split_feature_flag_google_sign_in":{"type":"boolean"},"au_split_feature_flag_product_search":{"type":"boolean"},"au_split_featureflag-chooseimagemodalflow":{"type":"boolean"},"editor_version":{"type":"string"},"is_mobile_view":{"type":"boolean"}},"additionalProperties":false,"required":[]},
          'CTA Impression': {"type":"object","properties":{"category":{"type":"string"},"ecomm_prodid":{"type":"string"},"is_customizable_product":{"type":"boolean"},"name":{"type":"string"},"price":{"type":"number"},"product_id":{"type":"number"},"product_line":{"type":"string"},"product_type":{"type":"string"},"products":{"items":{"type":"object"},"type":"array"},"sku":{"type":"string"}},"additionalProperties":false,"required":["category","name","product_id","product_line","sku"]},
          'CTA preview expanded': {"type":"object","properties":{"au_project_version":{"type":"string"},"au_split_editorV2_books":{"type":"string"},"au_split_editorV2_feature_flag_autofill":{"type":"boolean"},"au_split_editorV2_guestbookset":{"type":"string"},"au_split_editorV2_spread_books":{"type":"string"},"au_split_feature_flag_google_sign_in":{"type":"boolean"},"au_split_feature_flag_product_search":{"type":"boolean"},"au_split_featureflag-chooseimagemodalflow":{"type":"boolean"},"category":{"type":"string"},"ecomm_prodid":{"type":"string"},"editor_version":{"type":"string"},"is_customizable_product":{"type":"boolean"},"is_mobile_view":{"type":"boolean"},"name":{"type":"string"},"price":{"type":"number"},"product_id":{"type":"number"},"product_line":{"type":"string"},"product_type":{"type":"string"},"products":{"items":{"type":"object"},"type":"array"},"sku":{"type":"string"}},"additionalProperties":false,"required":["category","name","product_id","product_line","sku"]},
          'Design It Later Clicked': {"type":"object","properties":{"email":{"type":"string"},"is_logged_in":{"type":"boolean"},"product_id":{"type":"number"}},"additionalProperties":false,"required":["is_logged_in","product_id"]},
          'Design It Later Email Submitted': {"type":"object","properties":{"pdp_image":{"type":"string"},"pdp_url":{"type":"string"}},"additionalProperties":false,"required":["pdp_url"]},
          'DS button clicked': {"type":"object","properties":{"category":{"type":"string"},"ecomm_prodid":{"type":"string"},"is_customizable_product":{"type":"boolean"},"name":{"type":"string"},"price":{"type":"number"},"product_id":{"type":"number"},"product_line":{"type":"string"},"product_type":{"type":"string"},"products":{"items":{"type":"object"},"type":"array"},"sku":{"type":"string"}},"additionalProperties":false,"required":["category","name","product_id","product_line","sku"]},
          'Email Subscribed': {"type":"object","properties":{"customer_id":{"type":"string"},"email":{"type":"string"},"last_updated":{"type":"string"},"location":{"type":"string"},"subscription":{"type":"string"},"pdpUrl":{"type":"string"},"pdpImg":{"type":"string"}},"additionalProperties":false,"required":["customer_id","last_updated","location","subscription"]},
          'Filter Deselected': {"type":"object","properties":{"applied_filters":{"items":{"type":"object"},"type":"array"},"filter_option":{"type":"string"},"filter_value":{"type":"string"}},"additionalProperties":false,"required":[]},
          'Filter Selected': {"type":"object","properties":{"applied_filters":{"items":{"type":"object"},"type":"array"},"filter_option":{"type":"string"},"filter_value":{"type":"string"}},"additionalProperties":false,"required":[]},
          'First Purchase': {"type":"object","properties":{"order_id":{"type":"integer"},"subtotal":{"type":"number"}},"additionalProperties":false,"required":["order_id"]},
          'Image Upload Attempted': {"type":"object","properties":{"is_mobile_view":{"type":"boolean"},"source":{"type":"string"},"upload_selected_count":{"type":"string"},"upload_selected_extensions":{"type":"string"},"upload_selected_sizes":{"type":"string"},"upload_source":{"type":"string"}},"additionalProperties":false,"required":["upload_selected_count","upload_selected_extensions","upload_selected_sizes","upload_source"]},
          'Image Upload Completed': {"type":"object","properties":{"is_mobile_view":{"type":"boolean"},"source":{"type":"string"},"upload_completed_count":{"type":"number"},"upload_completed_extensions":{"type":"string"},"upload_completed_sizes":{"type":"string"},"upload_completed_time":{"type":"number"},"upload_source":{"type":"string"}},"additionalProperties":false,"required":["upload_completed_count","upload_completed_extensions","upload_completed_sizes","upload_completed_time","upload_source"]},
          'Image Upload Failed': {"type":"object","properties":{"is_mobile_view":{"type":"boolean"},"source":{"type":"string"},"upload_accepted_count":{"type":"string"},"upload_accepted_sizes":{"type":"string"},"upload_rejected_count":{"type":"string"},"upload_rejected_error_codes":{"type":"string"},"upload_rejected_extensions":{"type":"string"},"upload_rejected_sizes":{"type":"string"},"upload_source":{"type":"string"}},"additionalProperties":false,"required":["upload_accepted_count","upload_accepted_sizes","upload_rejected_count","upload_rejected_error_codes","upload_rejected_extensions","upload_rejected_sizes","upload_source"]},
          'Login Attempted': {"type":"object","properties":{"login_method":{"enum":["Google","Email"]}},"additionalProperties":false,"required":[]},
          'Login Completed': {"type":"object","properties":{"account_type":{"enum":["New","Existing","Unknown"]},"login_method":{"enum":["Google","Email"]}},"additionalProperties":false,"required":[]},
          'Login Started': {"type":"object","properties":{"login_type":{"enum":["Checkout","Project","Nav"]}},"additionalProperties":false,"required":[]},
          'My Projects Page Viewed': {"type":"object","properties":{"page_count":{"type":"number"},"page_version":{"type":"number"}},"additionalProperties":false,"required":["page_count"]},
          'Nav Link Clicked': {"type":"object","properties":{"click_zone":{"type":"string"},"link":{"type":"string"},"nav_header":{"type":"string"},"nav_section":{"type":"string"},"nav_subsection":{"type":"string"},"navigation_target":{"type":"string"}},"additionalProperties":false,"required":["click_zone","link","nav_header","navigation_target"]},
          'New Card Added': {"type":"object","properties":{"cart_id":{"type":"integer"},"shipping_options":{"items":{"type":"object"},"type":"array"}},"additionalProperties":false,"required":[]},
          'Option Preview Expanded': {"type":"object","properties":{"category":{"type":"string"},"ecomm_prodid":{"type":"string"},"is_customizable_product":{"type":"boolean"},"name":{"type":"string"},"option_attribute":{"type":"string"},"price":{"type":"number"},"product_id":{"type":"number"},"product_line":{"type":"string"},"product_type":{"type":"string"},"products":{"items":{"type":"object"},"type":"array"},"sku":{"type":"string"}},"additionalProperties":false,"required":["category","name","option_attribute","product_id","product_line","sku"]},
          'Order Completed': {"type":"object","properties":{"ab_test":{"type":"object"},"au_project_version":{"type":"string"},"au_split_editorV2_books":{"type":"string"},"au_split_editorV2_feature_flag_autofill":{"type":"boolean"},"au_split_editorV2_guestbookset":{"type":"string"},"au_split_editorV2_spread_books":{"type":"string"},"au_split_feature_flag_google_sign_in":{"type":"boolean"},"au_split_feature_flag_product_search":{"type":"boolean"},"au_split_featureflag-chooseimagemodalflow":{"type":"boolean"},"billing_country":{"type":"string"},"billing_phone":{"type":"string"},"billing_state":{"type":"string"},"billing_zip":{"type":"string"},"cart_id":{"type":"integer"},"coupon":{"type":"string"},"currency":{"type":"string"},"customer_ip":{"type":"string"},"discount":{"type":"number"},"editor_version":{"type":"string"},"email":{"type":"string"},"has_amazonpay":{"type":"boolean"},"is_mobile_view":{"type":"boolean"},"order_id":{"type":"integer"},"orderId":{"type":"number"},"payment_method":{"type":"string"},"products":{"items":{"type":"object"},"type":"array"},"repeat":{"type":"boolean"},"revenue":{"type":"number"},"shipping":{"type":"number"},"subtotal":{"type":"number"},"tax":{"type":"number"}},"additionalProperties":false,"required":["billing_country","billing_phone","billing_state","billing_zip","currency","discount","order_id","revenue","shipping"]},
          'Order Item Completed': {"type":"object","properties":{"ab_test":{"type":"object"},"au_project_version":{"type":"string"},"au_split_editorV2_books":{"type":"string"},"au_split_editorV2_feature_flag_autofill":{"type":"boolean"},"au_split_editorV2_guestbookset":{"type":"string"},"au_split_editorV2_spread_books":{"type":"string"},"au_split_feature_flag_google_sign_in":{"type":"boolean"},"au_split_feature_flag_product_search":{"type":"boolean"},"au_split_featureflag-chooseimagemodalflow":{"type":"boolean"},"cart_id":{"type":"number"},"category":{"type":"string"},"ecomm_prodid":{"type":"string"},"editor_version":{"type":"string"},"is_customizable_product":{"type":"boolean"},"is_mobile_view":{"type":"boolean"},"item_id":{"type":"number"},"name":{"type":"string"},"order_id":{"type":"integer"},"price":{"type":"number"},"product_id":{"type":"number"},"product_line":{"type":"string"},"product_type":{"type":"string"},"products":{"items":{"type":"object"},"type":"array"},"quantity":{"type":"integer"},"repeat":{"type":"boolean"},"revenue":{"type":"number"},"row_total":{"type":"number"},"sku":{"type":"string"}},"additionalProperties":false,"required":["category","name","order_id","product_id","product_line","quantity","revenue","sku"]},
          'Page Viewed': {"type":"object","properties":{"page_name":{"type":"string"},"page_type":{"type":"string"}},"additionalProperties":false,"required":["page_name","page_type"]},
          'Password Reset Started': {"type":"object","properties":{},"additionalProperties":false,"required":[]},
          'Payment Method at Checkout': {"type":"object","properties":{"payment_method":{"type":"string"}},"additionalProperties":false,"required":[]},
          'Payment Method Changed': {"type":"object","properties":{"cart_id":{"type":"integer"},"payment_method":{"type":"string"},"shipping_options":{"items":{"type":"object"},"type":"array"}},"additionalProperties":false,"required":[]},
          'PDP CTA Clicked': {"type":"object","properties":{"au_project_version":{"type":"string"},"au_split_editorV2_books":{"type":"string"},"au_split_editorV2_feature_flag_autofill":{"type":"boolean"},"au_split_editorV2_guestbookset":{"type":"string"},"au_split_editorV2_spread_books":{"type":"string"},"au_split_feature_flag_google_sign_in":{"type":"boolean"},"au_split_feature_flag_product_search":{"type":"boolean"},"au_split_featureflag-chooseimagemodalflow":{"type":"boolean"},"category":{"type":"string"},"ecomm_prodid":{"type":"string"},"editor_version":{"type":"string"},"is_customizable_product":{"type":"boolean"},"is_mobile_view":{"type":"boolean"},"name":{"type":"string"},"options_complete":{"type":"boolean"},"price":{"type":"number"},"product_id":{"type":"number"},"product_line":{"type":"string"},"product_type":{"type":"string"},"products":{"items":{"type":"object"},"type":"array"},"sku":{"type":"string"}},"additionalProperties":false,"required":["category","name","options_complete","product_id","product_line","sku"]},
          'PDP Option Clicked': {"type":"object","properties":{"category":{"type":"string"},"ecomm_prodid":{"type":"string"},"is_customizable_product":{"type":"boolean"},"name":{"type":"string"},"option_attribute":{"type":"string"},"option_display_name":{"type":"string"},"option_value":{"type":"string"},"price":{"type":"number"},"product_id":{"type":"number"},"product_line":{"type":"string"},"product_type":{"type":"string"},"products":{"items":{"type":"object"},"type":"array"},"sku":{"type":"string"}},"additionalProperties":false,"required":["category","name","option_attribute","option_display_name","option_value","product_id","product_line","sku"]},
          'Product Added': {"type":"object","properties":{"ab_test":{"type":"object"},"au_project_version":{"type":"string"},"au_split_editorV2_books":{"type":"string"},"au_split_editorV2_feature_flag_autofill":{"type":"boolean"},"au_split_editorV2_guestbookset":{"type":"string"},"au_split_editorV2_spread_books":{"type":"string"},"au_split_feature_flag_google_sign_in":{"type":"boolean"},"au_split_feature_flag_product_search":{"type":"boolean"},"au_split_featureflag-chooseimagemodalflow":{"type":"boolean"},"category":{"type":"string"},"customer_ip":{"type":"string"},"ecomm_prodid":{"type":"string"},"editor_version":{"type":"string"},"email":{"type":"string"},"is_customizable_product":{"type":"boolean"},"is_mobile_view":{"type":"boolean"},"location":{"type":"string"},"name":{"type":"string"},"price":{"type":"number"},"product_id":{"type":"number"},"product_line":{"type":"string"},"product_type":{"type":"string"},"products":{"items":{"type":"object"},"type":"array"},"project_id":{"type":"string"},"sku":{"type":"string"}},"additionalProperties":false,"required":["category","location","name","product_id","product_line","sku"]},
          'Product Assistant Expand Clicked': {"type":"object","properties":{"current_url":{"type":"string"}},"additionalProperties":false,"required":["current_url"]},
          'Product Assistant Link Clicked': {"type":"object","properties":{"current_url":{"type":"string"},"link":{"type":"string"}},"additionalProperties":false,"required":["current_url","link"]},
          'Product Assistant Message Sent': {"type":"object","properties":{"current_url":{"type":"string"},"user_message":{"type":"string"}},"additionalProperties":false,"required":["current_url","user_message"]},
          'Product Assistant Opened': {"type":"object","properties":{"current_url":{"type":"string"}},"additionalProperties":false,"required":["current_url"]},
          'Product Assistant Reset Clicked': {"type":"object","properties":{"current_url":{"type":"string"}},"additionalProperties":false,"required":["current_url"]},
          'Product Assistant Sample Question Arrow Clicked': {"type":"object","properties":{"arrow":{"enum":["left","right"]},"current_url":{"type":"string"}},"additionalProperties":false,"required":["arrow","current_url"]},
          'Product Assistant Sample Question Clicked': {"type":"object","properties":{"current_url":{"type":"string"},"index":{"type":"number"},"sample_question":{"type":"string"}},"additionalProperties":false,"required":["current_url","index","sample_question"]},
          'Product List Viewed': {"type":"object","properties":{"category":{"type":"string"},"products":{"items":{"type":"object"},"type":"array"}},"additionalProperties":false,"required":["category","products"]},
          'Product Quantity Changed': {"type":"object","properties":{"cart_id":{"type":"integer"},"new_quantity":{"type":"number"},"product_id":{"type":"number"},"sku":{"type":"string"}},"additionalProperties":false,"required":["new_quantity","product_id","sku"]},
          'Product Removed': {"type":"object","properties":{"cart_id":{"type":"integer"},"price":{"type":"number"},"product_id":{"type":"number"},"sku":{"type":"string"}},"additionalProperties":false,"required":["product_id","sku"]},
          'Product Viewed': {"type":"object","properties":{"category":{"type":"string"},"ecomm_prodid":{"type":"string"},"is_customizable_product":{"type":"boolean"},"name":{"type":"string"},"price":{"type":"number"},"product_id":{"type":"number"},"product_line":{"type":"string"},"product_type":{"type":"string"},"products":{"items":{"type":"object"},"type":"array"},"sku":{"type":"string"}},"additionalProperties":false,"required":["category","name","product_id","product_line","sku"]},
          'Project Clicked': {"type":"object","properties":{"click_type":{"enum":["card","kabob"]},"page_version":{"type":"number"}},"additionalProperties":false,"required":["click_type"]},
          'Project Deleted': {"type":"object","properties":{"category":{"type":"string"},"ecomm_prodid":{"type":"string"},"is_customizable_product":{"type":"boolean"},"name":{"type":"string"},"price":{"type":"number"},"product_id":{"type":"number"},"product_line":{"type":"string"},"product_type":{"type":"string"},"products":{"items":{"type":"object"},"type":"array"},"project_id":{"type":"string"},"sku":{"type":"string"}},"additionalProperties":false,"required":["category","name","product_id","product_line","project_id","sku"]},
          'Project Duplicated': {"type":"object","properties":{"category":{"type":"string"},"ecomm_prodid":{"type":"string"},"is_customizable_product":{"type":"boolean"},"name":{"type":"string"},"price":{"type":"number"},"product_id":{"type":"number"},"product_line":{"type":"string"},"product_type":{"type":"string"},"products":{"items":{"type":"object"},"type":"array"},"project_id":{"type":"string"},"sku":{"type":"string"}},"additionalProperties":false,"required":["category","name","product_id","product_line","project_id","sku"]},
          'Project Edited': {"type":"object","properties":{"category":{"type":"string"},"ecomm_prodid":{"type":"string"},"is_customizable_product":{"type":"boolean"},"name":{"type":"string"},"price":{"type":"number"},"product_id":{"type":"number"},"product_line":{"type":"string"},"product_type":{"type":"string"},"products":{"items":{"type":"object"},"type":"array"},"project_id":{"type":"string"},"sku":{"type":"string"}},"additionalProperties":false,"required":["category","name","product_id","product_line","project_id","sku"]},
          'Project Info Viewed': {"type":"object","properties":{"project_info":{"type":"string"}},"additionalProperties":false,"required":[]},
          'Project Renamed': {"type":"object","properties":{},"additionalProperties":false,"required":[]},
          'Return to Project Clicked': {"type":"object","properties":{"click_type":{"enum":["Continue","All projects"]}},"additionalProperties":false,"required":["click_type"]},
          'Return to Project Dismissed': {"type":"object","properties":{},"additionalProperties":false,"required":[]},
          'Return to Project Impression': {"type":"object","properties":{},"additionalProperties":false,"required":[]},
          'Search result selected': {"type":"object","properties":{"result_term":{"type":"string"},"search_term":{"type":"string"}},"additionalProperties":false,"required":["result_term","search_term"]},
          'Search started': {"type":"object","properties":{},"additionalProperties":false,"required":[]},
          'Split Treatment Received': {"type":"object","properties":{"split_anonymous_key":{"type":"string"},"split_name":{"type":"string"},"split_treatment":{"type":"string"}},"additionalProperties":false,"required":["split_name","split_treatment"]},
          'Visual Nav Clicked': {"type":"object","properties":{"filter_option":{"type":"string"},"filter_value":{"type":"string"},"subcategory_name":{"type":"string"}},"additionalProperties":false,"required":["subcategory_name"]},
        }),
        ...destinationPlugins,
        ...plugins,
      ],
    });
  }

  /**
   * Alias a user ID to another user ID.
   * @param userId The user's new ID.
   * @param previousId The user's previous ID.
   * @param options Options for this alias call.
   */
  alias(userId: string, previousId?: string, options?: AliasOptions) {
    this.itly.alias(userId, previousId, options);
  }

  /**
   * Identify a user and set or update that user's properties.
   * @param userId The user's ID.
   * @param properties The user's properties.
   * @param options Options for this identify call.
   */
  identify(
    userId: string | undefined,
    properties?: IdentifyProperties,
    options?: IdentifyOptions,
  ) {
    this.itly.identify(userId, properties, options);
  }

  /**
   * Associate the current user with a group.
   * @param groupId The group's ID.
   * @param options Options for this group call.
   */
  group(
    groupId: string,
    options?: GroupOptions,
  ) {
    this.itly.group(groupId, undefined, options);
  }

  /**
   * Track a page view.
   * @param category The page's category.
   * @param name The page's name.
   * @param options Options for this page call.
   */
  page(
    category: string,
    name: string,
    options?: PageOptions,
  ) {
    this.itly.page(category, name, undefined, options);
  }

  /**
   * **When user views the “Create an Account” form, trigger event “Account Create Started”**
   * @param options Options for this track call.
   */
  accountCreateStarted(
    options?: TrackOptions,
  ) {
    this.itly.track(new AccountCreateStarted(), options);
  }

  /**
   * User created a new account
   *
   * Owner: carly@artifactuprising.com
   * @param properties The event's properties (e.g. email)
   * @param options Options for this track call.
   */
  accountCreated(
    properties: AccountCreatedProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new AccountCreated(properties), options);
  }

  /**
   * Fires when a promo code is applied
   * @param properties The event's properties (e.g. cart_id)
   * @param options Options for this track call.
   */
  applyPromoCode(
    properties: ApplyPromoCodeProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new ApplyPromoCode(properties), options);
  }

  /**
   * Fires when a adding a promo code causes an error
   * @param properties The event's properties (e.g. cart_id)
   * @param options Options for this track call.
   */
  applyPromoCodeError(
    properties: ApplyPromoCodeErrorProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new ApplyPromoCodeError(properties), options);
  }

  /**
   * When a user hits an asset on the home page
   *
   * Owner: Infra Structure
   * @param properties The event's properties (e.g. creative)
   * @param options Options for this track call.
   */
  assetClicked(
    properties: AssetClickedProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new AssetClicked(properties), options);
  }

  /**
   * Event to track the total time taken for the cart page to load.
   * @param properties The event's properties (e.g. cart_id)
   * @param options Options for this track call.
   */
  cartPageTotalLoadTime(
    properties: CartPageTotalLoadTimeProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new CartPageTotalLoadTime(properties), options);
  }

  /**
   * User viewed their shopping cart
   *
   * Owner: carly@artifactuprising.com
   * @param properties The event's properties (e.g. au_project_version)
   * @param options Options for this track call.
   */
  cartViewed(
    properties: CartViewedProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new CartViewed(properties), options);
  }

  /**
Event has no description in tracking plan.
   * @param properties The event's properties (e.g. cart_id)
   * @param options Options for this track call.
   */
  checkoutError(
    properties: CheckoutErrorProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new CheckoutError(properties), options);
  }

  /**
   * Tracks total load time of the checkout page (/checkout)
   * @param properties The event's properties (e.g. cart_id)
   * @param options Options for this track call.
   */
  checkoutPageTotalLoadTime(
    properties: CheckoutPageTotalLoadTimeProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new CheckoutPageTotalLoadTime(properties), options);
  }

  /**
   * User initiated the order process by clicking "CONTINUE TO CHECKOUT" in the Shopping Cart
   *
   * Owner: carly@artifactuprising.com
   * @param properties The event's properties (e.g. cart_id)
   * @param options Options for this track call.
   */
  checkoutStarted(
    properties: CheckoutStartedProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new CheckoutStarted(properties), options);
  }

  /**
   * Fire this event whenever a checkout step is completed.
   *
   * Owner: carly@artifactuprising.com
   * @param properties The event's properties (e.g. au_project_version)
   * @param options Options for this track call.
   */
  checkoutStepCompleted(
    properties: CheckoutStepCompletedProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new CheckoutStepCompleted(properties), options);
  }

  /**
   * Fire this event whenever a checkout step is viewed.
   *
   * Owner: carly@artifactuprising.com
   * @param properties The event's properties (e.g. au_project_version)
   * @param options Options for this track call.
   */
  checkoutStepViewed(
    properties: CheckoutStepViewedProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new CheckoutStepViewed(properties), options);
  }

  /**
   * A user has received an empty result set
   *
   * Owner: ester.sosa@nan-labs.com
   * @param properties The event's properties (e.g. filters_selected)
   * @param options Options for this track call.
   */
  clpEmptyResults(
    properties?: ClpEmptyResultsProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new ClpEmptyResults(properties), options);
  }

  /**
   * Fires when a user clicks on a product link on a CLP (the text link)
   *
   * Owner: Dev Devington
   * @param properties The event's properties (e.g. card_number)
   * @param options Options for this track call.
   */
  clpLinkClicked(
    properties: CLPLinkClickedProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new ClpLinkClicked(properties), options);
  }

  /**
   * Fires when a user swipes to/selects a new image on the CLP carousel (displays in mobile only)
   * @param properties The event's properties (e.g. card_number)
   * @param options Options for this track call.
   */
  clpLinkSwipe(
    properties: CLPLinkSwipeProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new ClpLinkSwipe(properties), options);
  }

  /**
   * Load time for the specified component
   * @param properties The event's properties (e.g. cart_id)
   * @param options Options for this track call.
   */
  componentLoaded(
    properties: ComponentLoadedProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new ComponentLoaded(properties), options);
  }

  /**
   * Owner: Dev Devington
   * @param properties The event's properties (e.g. au_project_version)
   * @param options Options for this track call.
   */
  consentDefined(
    properties: ConsentDefinedProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new ConsentDefined(properties), options);
  }

  /**
   * Owner: Dev Devington
   * @param properties The event's properties (e.g. au_project_version)
   * @param options Options for this track call.
   */
  consentPreferencesOpened(
    properties?: ConsentPreferencesOpenedProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new ConsentPreferencesOpened(properties), options);
  }

  /**
   * on PDP when either the add to cart/start project button is displayed to customer
   *
   * Owner: Dev Devington
   * @param properties The event's properties (e.g. category)
   * @param options Options for this track call.
   */
  ctaImpression(
    properties: CTAImpressionProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new CtaImpression(properties), options);
  }

  /**
   * Owner: Dev Devington
   * @param properties The event's properties (e.g. au_project_version)
   * @param options Options for this track call.
   */
  ctaPreviewExpanded(
    properties: CTAPreviewExpandedProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new CtaPreviewExpanded(properties), options);
  }

  /**
   * A user clicks 'design it later on my computer' on a PDP
   * @param properties The event's properties (e.g. email)
   * @param options Options for this track call.
   */
  designItLaterClicked(
    properties: DesignItLaterClickedProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new DesignItLaterClicked(properties), options);
  }

  /**
Event has no description in tracking plan.
   * @param properties The event's properties (e.g. pdp_image)
   * @param options Options for this track call.
   */
  designItLaterEmailSubmitted(
    properties: DesignItLaterEmailSubmittedProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new DesignItLaterEmailSubmitted(properties), options);
  }

  /**
   * Owner: Dev Devington
   * @param properties The event's properties (e.g. category)
   * @param options Options for this track call.
   */
  dsButtonClicked(
    properties: DSButtonClickedProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new DsButtonClicked(properties), options);
  }

  /**
   * Owner: Dev Devington
   * @param properties The event's properties (e.g. customer_id)
   * @param options Options for this track call.
   */
  emailSubscribed(
    properties: EmailSubscribedProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new EmailSubscribed(properties), options);
  }

  /**
   * What filters has the user deselected
   *
   * Owner: ester.sosa@nan-labs.com
   * @param properties The event's properties (e.g. applied_filters)
   * @param options Options for this track call.
   */
  filterDeselected(
    properties?: FilterDeselectedProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new FilterDeselected(properties), options);
  }

  /**
   * What filters has a user selected
   *
   * Owner: ester.sosa@nan-labs.com
   * @param properties The event's properties (e.g. applied_filters)
   * @param options Options for this track call.
   */
  filterSelected(
    properties?: FilterSelectedProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new FilterSelected(properties), options);
  }

  /**
   * Is this the first purchase a user has made
   * @param properties The event's properties (e.g. order_id)
   * @param options Options for this track call.
   */
  firstPurchase(
    properties: FirstPurchaseProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new FirstPurchase(properties), options);
  }

  /**
   * User begins the file upload process by selecting files (files have not been uploaded yet)
   * @param properties The event's properties (e.g. is_mobile_view)
   * @param options Options for this track call.
   */
  imageUploadAttempted(
    properties: ImageUploadAttemptedProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new ImageUploadAttempted(properties), options);
  }

  /**
   * Fires when a batch of uploads is complete (i.e., the files have been stored in S3 and the gallery images have been created). This will always fire after Image Upload Attempted and Image Selected.
   * @param properties The event's properties (e.g. is_mobile_view)
   * @param options Options for this track call.
   */
  imageUploadCompleted(
    properties: ImageUploadCompletedProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new ImageUploadCompleted(properties), options);
  }

  /**
Event has no description in tracking plan.
   * @param properties The event's properties (e.g. is_mobile_view)
   * @param options Options for this track call.
   */
  imageUploadFailed(
    properties: ImageUploadFailedProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new ImageUploadFailed(properties), options);
  }

  /**
   * Fires when a user clicks a login button on the login page
   *
   * Owner: Infra Structure
   * @param properties The event's properties (e.g. login_method)
   * @param options Options for this track call.
   */
  loginAttempted(
    properties?: LoginAttemptedProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new LoginAttempted(properties), options);
  }

  /**
   * Owner: Dev Devington
   * @param properties The event's properties (e.g. account_type)
   * @param options Options for this track call.
   */
  loginCompleted(
    properties?: LoginCompletedProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new LoginCompleted(properties), options);
  }

  /**
   * Owner: Dev Devington
   * @param properties The event's properties (e.g. login_type)
   * @param options Options for this track call.
   */
  loginStarted(
    properties?: LoginStartedProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new LoginStarted(properties), options);
  }

  /**
   * Owner: Infra Structure
   * @param properties The event's properties (e.g. page_count)
   * @param options Options for this track call.
   */
  myProjectsPageViewed(
    properties: MyProjectsPageViewedProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new MyProjectsPageViewed(properties), options);
  }

  /**
   * When a user clicks on a link in the top nav bar
   *
   * Owner: Infra Structure
   * @param properties The event's properties (e.g. click_zone)
   * @param options Options for this track call.
   */
  navLinkClicked(
    properties: NavLinkClickedProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new NavLinkClicked(properties), options);
  }

  /**
   * Event to track when a gift card is added to an order.
   * @param properties The event's properties (e.g. cart_id)
   * @param options Options for this track call.
   */
  newCardAdded(
    properties?: NewCardAddedProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new NewCardAdded(properties), options);
  }

  /**
   * Owner: Dev Devington
   * @param properties The event's properties (e.g. category)
   * @param options Options for this track call.
   */
  optionPreviewExpanded(
    properties: OptionPreviewExpandedProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new OptionPreviewExpanded(properties), options);
  }

  /**
   * User completed the order. This event should only fire 1 time per order as it aggregates to the order level. Should only fire once the credit card is validated and the transaction goes through successfully.
   *
   * Owner: carly@artifactuprising.com
   * @param properties The event's properties (e.g. ab_test)
   * @param options Options for this track call.
   */
  orderCompleted(
    properties: OrderCompletedProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new OrderCompleted(properties), options);
  }

  /**
   * This event should fire for each item purchased in an order; it can fire 1 or more times per order. This will be used for funnel analysis in Heap.
   *
   * Owner: carly@artifactuprising.com
   * @param properties The event's properties (e.g. ab_test)
   * @param options Options for this track call.
   */
  orderItemCompleted(
    properties: OrderItemCompletedProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new OrderItemCompleted(properties), options);
  }

  /**
   * Called when any page is viewed. Should be called whenever "Page" is called. Only call once when in the editor.
   *
   * Owner: carly@artifactuprising.com
   * @param properties The event's properties (e.g. page_name)
   * @param options Options for this track call.
   */
  pageViewed(
    properties: PageViewedProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new PageViewed(properties), options);
  }

  /**
   * Owner: Dev Devington
   * @param options Options for this track call.
   */
  passwordResetStarted(
    options?: TrackOptions,
  ) {
    this.itly.track(new PasswordResetStarted(), options);
  }

  /**
   * Tracks the payment method used by the customer when they hit the Purchase button
   * @param properties The event's properties (e.g. payment_method)
   * @param options Options for this track call.
   */
  paymentMethodAtCheckout(
    properties?: PaymentMethodAtCheckoutProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new PaymentMethodAtCheckout(properties), options);
  }

  /**
   * A user has changed their payment method and selected "Update Payment"
   * @param properties The event's properties (e.g. cart_id)
   * @param options Options for this track call.
   */
  paymentMethodChanged(
    properties?: PaymentMethodChangedProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new PaymentMethodChanged(properties), options);
  }

  /**
   * Owner: Dev Devington
   * @param properties The event's properties (e.g. au_project_version)
   * @param options Options for this track call.
   */
  pdpctaClicked(
    properties: PDPCTAClickedProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new PdpctaClicked(properties), options);
  }

  /**
   * Fires when a user clicks on an option for a product attribtue on the PDP
   *
   * Owner: Dev Devington
   * @param properties The event's properties (e.g. category)
   * @param options Options for this track call.
   */
  pdpOptionClicked(
    properties: PDPOptionClickedProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new PdpOptionClicked(properties), options);
  }

  /**
   * User added a product to their shopping cart
   *
   * Owner: carly@artifactuprising.com
   * @param properties The event's properties (e.g. ab_test)
   * @param options Options for this track call.
   */
  productAdded(
    properties: ProductAddedProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new ProductAdded(properties), options);
  }

  /**
Event has no description in tracking plan.
   * @param properties The event's properties (e.g. current_url)
   * @param options Options for this track call.
   */
  productAssistantExpandClicked(
    properties: ProductAssistantExpandClickedProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new ProductAssistantExpandClicked(properties), options);
  }

  /**
Event has no description in tracking plan.
   * @param properties The event's properties (e.g. current_url)
   * @param options Options for this track call.
   */
  productAssistantLinkClicked(
    properties: ProductAssistantLinkClickedProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new ProductAssistantLinkClicked(properties), options);
  }

  /**
Event has no description in tracking plan.
   * @param properties The event's properties (e.g. current_url)
   * @param options Options for this track call.
   */
  productAssistantMessageSent(
    properties: ProductAssistantMessageSentProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new ProductAssistantMessageSent(properties), options);
  }

  /**
Event has no description in tracking plan.
   * @param properties The event's properties (e.g. current_url)
   * @param options Options for this track call.
   */
  productAssistantOpened(
    properties: ProductAssistantOpenedProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new ProductAssistantOpened(properties), options);
  }

  /**
Event has no description in tracking plan.
   * @param properties The event's properties (e.g. current_url)
   * @param options Options for this track call.
   */
  productAssistantResetClicked(
    properties: ProductAssistantResetClickedProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new ProductAssistantResetClicked(properties), options);
  }

  /**
Event has no description in tracking plan.
   * @param properties The event's properties (e.g. arrow)
   * @param options Options for this track call.
   */
  productAssistantSampleQuestionArrowClicked(
    properties: ProductAssistantSampleQuestionArrowClickedProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new ProductAssistantSampleQuestionArrowClicked(properties), options);
  }

  /**
Event has no description in tracking plan.
   * @param properties The event's properties (e.g. current_url)
   * @param options Options for this track call.
   */
  productAssistantSampleQuestionClicked(
    properties: ProductAssistantSampleQuestionClickedProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new ProductAssistantSampleQuestionClicked(properties), options);
  }

  /**
   * User viewed a product list or category
   *
   * Owner: carly@artifactuprising.com
   * @param properties The event's properties (e.g. category)
   * @param options Options for this track call.
   */
  productListViewed(
    properties: ProductListViewedProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new ProductListViewed(properties), options);
  }

  /**
   * User changes the quantity of a product in the cart
   * @param properties The event's properties (e.g. cart_id)
   * @param options Options for this track call.
   */
  productQuantityChanged(
    properties: ProductQuantityChangedProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new ProductQuantityChanged(properties), options);
  }

  /**
   * Customer removes product from cart
   * @param properties The event's properties (e.g. cart_id)
   * @param options Options for this track call.
   */
  productRemoved(
    properties: ProductRemovedProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new ProductRemoved(properties), options);
  }

  /**
   * User viewed product display page (PDP)
   *
   * Owner: carly@artifactuprising.com
   * @param properties The event's properties (e.g. category)
   * @param options Options for this track call.
   */
  productViewed(
    properties: ProductViewedProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new ProductViewed(properties), options);
  }

  /**
   * Triggered when a project is clicked on the My Projects page
   *
   * Owner: Infra Structure
   * @param properties The event's properties (e.g. click_type)
   * @param options Options for this track call.
   */
  projectClicked(
    properties: ProjectClickedProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new ProjectClicked(properties), options);
  }

  /**
   * User deleted a project
   *
   * Owner: Santiago Navarro
   * @param properties The event's properties (e.g. category)
   * @param options Options for this track call.
   */
  projectDeleted(
    properties: ProjectDeletedProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new ProjectDeleted(properties), options);
  }

  /**
   * User duplicated an existing project
   *
   * Owner: Santiago Navarro
   * @param properties The event's properties (e.g. category)
   * @param options Options for this track call.
   */
  projectDuplicated(
    properties: ProjectDuplicatedProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new ProjectDuplicated(properties), options);
  }

  /**
   * User edited a project
   *
   * Owner: carly@artifactuprising.com
   * @param properties The event's properties (e.g. category)
   * @param options Options for this track call.
   */
  projectEdited(
    properties: ProjectEditedProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new ProjectEdited(properties), options);
  }

  /**
   * When the user clicks the Project Info button in the kabob menu, the event fires
   *
   * Owner: Infra Structure
   * @param properties The event's properties (e.g. project_info)
   * @param options Options for this track call.
   */
  projectInfoViewed(
    properties?: ProjectInfoViewedProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new ProjectInfoViewed(properties), options);
  }

  /**
   * This event fires when a project is renamed from the My Projects grid (does not fire if the name is not changed)
   *
   * Owner: Infra Structure
   * @param options Options for this track call.
   */
  projectRenamed(
    options?: TrackOptions,
  ) {
    this.itly.track(new ProjectRenamed(), options);
  }

  /**
   * Event fires when the user clicks one of the links in the return to project experience
   *
   * Owner: Infra Structure
   * @param properties The event's properties (e.g. click_type)
   * @param options Options for this track call.
   */
  returnToProjectClicked(
    properties: ReturnToProjectClickedProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new ReturnToProjectClicked(properties), options);
  }

  /**
   * Event fires when the Return to Project experience is dismissed
   *
   * Owner: Infra Structure
   * @param options Options for this track call.
   */
  returnToProjectDismissed(
    options?: TrackOptions,
  ) {
    this.itly.track(new ReturnToProjectDismissed(), options);
  }

  /**
   * Event fires when the return to project experience is shown to the user on the home page
   *
   * Owner: Infra Structure
   * @param options Options for this track call.
   */
  returnToProjectImpression(
    options?: TrackOptions,
  ) {
    this.itly.track(new ReturnToProjectImpression(), options);
  }

  /**
   * Event fired on the commerce(au-commerce-gatsby repo), upon on selection of product name suggestion, after the user starts typing.
   *
   * Owner: Infra Structure
   * @param properties The event's properties (e.g. result_term)
   * @param options Options for this track call.
   */
  searchResultSelected(
    properties: SearchResultSelectedProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new SearchResultSelected(properties), options);
  }

  /**
   * Event fires when the user clicks the search icon for product searching in commerce
   *
   * Owner: Infra Structure
   * @param options Options for this track call.
   */
  searchStarted(
    options?: TrackOptions,
  ) {
    this.itly.track(new SearchStarted(), options);
  }

  /**
   * Event sent after Split is initialized and treatment is received
   *
   * Owner: Dev Devington
   * @param properties The event's properties (e.g. split_anonymous_key)
   * @param options Options for this track call.
   */
  splitTreatmentReceived(
    properties: SplitTreatmentReceivedProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new SplitTreatmentReceived(properties), options);
  }

  /**
   * Tracks when customers click the Visual Nav at the top of the CLP
   * @param properties The event's properties (e.g. filter_option)
   * @param options Options for this track call.
   */
  visualNavClicked(
    properties: VisualNavClickedProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new VisualNavClicked(properties), options);
  }

  /**
   * Track any event.
   * @param event The event to track.
   * @param options Options for this track call.
   */
  track(event: Event, options?: TrackOptions) {
    this.itly.track(event, options);
  }

  /**
   * Reset (e.g. on logout) all analytics state for the current user and group.
   */
  reset() {
    this.itly.reset();
  }

  async flush() {
    await this.itly.flush();
  }
}

export default new Itly();
